const styles = `/* stylelint-disable-next-line */
:root {
  --goto-blur-100: 4px;
  --goto-blur-200: 12px;
  --goto-blur-300: 24px;
  --goto-blur-400: 36px;
  --goto-blur-large: 50px;
  --goto-blur-medium: 30px;
  --goto-blur-small: 10px;
  --goto-blur-xlarge: 70px;
  --goto-elevation-100: 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.04);
  --goto-elevation-200: 0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.08), 0 1px 10px 0 rgba(0, 0, 0, 0.04);
  --goto-elevation-300: 0 5px 5px -3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.08), 0 3px 14px 2px rgba(0, 0, 0, 0.04);
  --goto-elevation-400: 0 8px 10px -5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.08), 0 6px 30px 5px rgba(0, 0, 0, 0.04);
  --goto-elevation-large: 0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2);
  --goto-elevation-medium: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
  --goto-elevation-none: none;
  --goto-elevation-small: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
  --goto-elevation-xlarge: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
  --goto-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --goto-font-family-mono: Menlo, Consolas, Monaco, 'Liberation Mono', 'Lucida Console', monospace;
  --goto-menu-width: 240px;
  --goto-topbar-background: var(--goto-ui-base-01);
  --goto-topbar-border: var(--goto-border);
  --goto-navigation-rail-background: var(--goto-ui-base-01);
  --goto-navigation-rail-border-right: var(--goto-border);
  --goto-navigation-rail-item-hover: var(--goto-hover-tertiary);
  --goto-navigation-rail-item-active: var(--goto-pressed-tertiary);
  --goto-navigation-rail-item-selected: transparent;
  --goto-navigation-rail-item-disabled: transparent;
  --goto-navigation-rail-icon: var(--goto-text-02);
  --goto-navigation-rail-icon-selected: var(--goto-icon-01);
  --goto-navigation-rail-icon-disabled: var(--goto-text-03);
  --goto-navigation-rail-text: var(--goto-text-02);
  --goto-navigation-rail-text-selected: var(--goto-text-02);
  --goto-navigation-rail-text-disabled: var(--goto-text-03);
  --goto-navigation-rail-focus: var(--goto-focus);
  --goto-navigation-rail-highlight: var(--goto-highlight);
  --goto-avatar-24: 700 0.625rem/0.875rem var(--goto-font-family);
  --goto-avatar-30: 700 0.75rem/1.065rem var(--goto-font-family);
  --goto-avatar-36: 700 0.875rem/0.9975rem var(--goto-font-family);
  --goto-avatar-48: 700 1.25rem/1.5rem var(--goto-font-family);
  --goto-avatar-64: 700 1.667rem/1.93372rem var(--goto-font-family);
  --goto-avatar-80: 700 2.25rem/2.6775rem var(--goto-font-family);
  --goto-avatar-180: 700 5.063rem/6.02497rem var(--goto-font-family);
  --goto-code-text-small: 400 0.75rem/0.9975rem var(--goto-font-family-mono);
  --goto-code-text-medium: 400 0.875rem/1.225rem var(--goto-font-family-mono);
  --goto-body-small: 400 0.875rem/1.5rem var(--goto-font-family);
  --goto-body-medium: 400 1rem/1.5rem var(--goto-font-family);
  --goto-body-large: 400 1.125rem/1.5rem var(--goto-font-family);
  --goto-body-small-semibold: 600 0.875rem/1.225rem var(--goto-font-family);
  --goto-body-medium-semibold: 600 1rem/1.4rem var(--goto-font-family);
  --goto-button-text-small: 600 0.75rem/1.05rem var(--goto-font-family);
  --goto-button-text-medium: 600 0.875rem/1.225rem var(--goto-font-family);
  --goto-button-text-large: 600 1rem/1.575rem var(--goto-font-family);
  --goto-button-text-xlarge: 600 1.125rem/1.575rem var(--goto-font-family);
  --goto-caption-default-01: 400 0.75rem/1.05rem var(--goto-font-family);
  --goto-caption-default-02: 600 0.75rem/1.05rem var(--goto-font-family);
  --goto-caption-small-01: 400 0.625rem/0.875rem var(--goto-font-family);
  --goto-caption-small-02: 600 0.625rem/0.875rem var(--goto-font-family);
  --goto-heading-small: 600 1.25rem/1.5rem var(--goto-font-family);
  --goto-heading-medium: 600 1.75rem/2rem var(--goto-font-family);
  --goto-heading-large: 700 2.25rem/2.5rem var(--goto-font-family);
  --goto-heading-xlarge: 700 3rem/3.25rem var(--goto-font-family);
  --goto-avatar-large: 700 1.25rem/1.5rem var(--goto-font-family);
  --goto-avatar-medium: 700 0.875rem/1.25rem var(--goto-font-family);
  --goto-avatar-small: 700 0.75rem/1rem var(--goto-font-family);
  --goto-avatar-xlarge: 700 1.625rem/2rem var(--goto-font-family);
  --goto-avatar-xsmall: 700 0.625rem/1rem var(--goto-font-family);
  --goto-avatar-xxlarge: 700 2.25rem/3rem var(--goto-font-family);
  --goto-avatar-xxxlarge: 700 5rem/6.25rem var(--goto-font-family);
  --goto-body-large-strong: 600 1.125rem/1.5rem var(--goto-font-family);
  --goto-body-medium-strong: 600 1rem/1.5rem var(--goto-font-family);
  --goto-body-small-strong: 600 0.875rem/1.5rem var(--goto-font-family);
  --goto-button-large: 600 1rem/1.5rem var(--goto-font-family);
  --goto-button-medium: 600 0.875rem/1.5rem var(--goto-font-family);
  --goto-button-small: 600 0.75rem/1.25rem var(--goto-font-family);
  --goto-button-xlarge: 600 1.125rem/1.5rem var(--goto-font-family);
  --goto-caption-medium: 400 0.75rem/1.25rem var(--goto-font-family);
  --goto-caption-medium-strong: 600 0.75rem/1.25rem var(--goto-font-family);
  --goto-caption-small: 400 0.625rem/1rem var(--goto-font-family);
  --goto-caption-small-strong: 600 0.625rem/1rem var(--goto-font-family);
  --goto-code-medium: 400 0.875rem/1.5rem var(--goto-font-family-mono);
  --goto-code-small: 400 0.75rem/1.25rem var(--goto-font-family-mono);
  --goto-layout-00: 0;
  --goto-layout-01: 16px;
  --goto-layout-02: 24px;
  --goto-layout-03: 32px;
  --goto-layout-04: 48px;
  --goto-layout-05: 64px;
  --goto-layout-06: 96px;
  --goto-layout-07: 160px;
  --goto-meeting: #F68D2E;
  --goto-room: #F68D2E;
  --goto-connect: #C4D600;
  --goto-webinar: #00C0F3;
  --goto-assist: #24658a;
  --goto-resolve: #7D33FF;
  --goto-training: #992977;
  --goto-open-voice: #a28bc4;
  --goto-jive: #cfe012;
  --goto-spacing-00: 0rem;
  --goto-spacing-01: 4px;
  --goto-spacing-02: 8px;
  --goto-spacing-03: 12px;
  --goto-spacing-04: 16px;
  --goto-spacing-05: 20px;
  --goto-spacing-06: 24px;
  --goto-spacing-07: 32px;
  --goto-spacing-08: 40px;
  --goto-spacing-09: 48px;
  --goto-spacing-10: 3.5rem;
  --goto-spacing-11: 4rem;
  --goto-transition-dialog-in: visibility 0s linear 0s, opacity 250ms 0s, transform 250ms;
  --goto-transition-dialog-out: visibility 0s linear 250ms, opacity 250ms 0s, transform 250ms;
  --goto-radius-circle: 1000px;
  --goto-radius-large: 12px;
  --goto-radius-medium: 8px;
  --goto-radius-none: 0px;
  --goto-radius-small: 4px;
  --goto-radius-xlarge: 16px;
  --goto-checkbox-checked-hover: var(--goto-hover-primary);
  --goto-checkbox-checked-pressed: var(--goto-pressed-primary);
  --goto-badge-background-disabled: var(--goto-disabled-02);
  --goto-badge-icon-disabled: var(--goto-disabled-04);
  --goto-alert-background: var(--goto-information-02);
  --goto-alert-border: var(--goto-interactive-01);
  --goto-chip-background: var(--goto-disabled-02);
  --goto-chip-background-selected: var(--goto-interactive-01);
  --goto-chip-background-selected-hover: var(--goto-hover-primary);
  --goto-chip-background-selected-active: var(--goto-pressed-primary);
  --goto-search-field-background: var(--goto-disabled-02);
  --goto-search-field-background-active: transparent;
  --goto-search-field-border-hover: var(--goto-disabled-02);
  --goto-search-field-icon-disabled: var(--goto-text-03);
  --goto-search-field-text-disabled: var(--goto-text-01);
  --goto-search-field-background-disabled: var(--goto-disabled-02);
  --goto-search-field-opacity-disabled: var(--disabled-opacity);
  --goto-search-field-clear-icon-background: var(--goto-text-02);
  --goto-select-inline-border: transparent;
  --goto-select-inline-font: var(--goto-caption-default-02);
  --goto-select-inline-border-hover: var(--goto-field-01);
  --goto-select-inline-background-hover: var(--goto-hover-secondary);
  --goto-select-inline-border-active: var(--goto-pressed-secondary);
  --goto-select-inline-background-active: var(--goto-pressed-secondary);
  --goto-round-button-icon-color: var(--goto-icon-01);
  --goto-round-button-border-success: var(--goto-success-01);
  --goto-round-button-border-danger: var(--goto-danger-01);
  --goto-tabs-indicator-background: var(--goto-interactive-01);
  --goto-skeleton-gradient: linear-gradient(90deg, transparent, var(--goto-disabled-01), transparent);
  --goto-input-success-border: var(--goto-success-01);
  --goto-input-danger-border: var(--goto-danger-01);
  --goto-nav-drawer-item-background-selected: var(--goto-interactive-01);
  --goto-nav-drawer-item-icon-color: var(--goto-text-02);
  --goto-nav-drawer-item-icon-color-selected: var(--goto-text-04);
  --goto-avatar-background-secondary-disabled: var(--goto-inverse-ui-05);
  --goto-avatar-color-secondary-disabled: var(--goto-disabled-04);
  --goto-avatar-border-secondary-disabled: 1px solid var(--goto-disabled-04);
  --goto-popover-border-color: var(--goto-ui-02);
  --goto-popover-elevation: var(--goto-elevation-300);
  --goto-empty-state-icon-color: var(--goto-disabled-04);
  --goto-radio-button-border-disabled: var(--goto-border);
  --goto-menu-background: inherit;
  --goto-menu-background-hover: var(--goto-interactive-01);
  --goto-menu-color-disabled: var(--goto-text-03);
  --goto-menu-color-hover: var(--goto-text-04);
  --goto-menu-icon-color: var(--goto-text-02);
  --goto-menu-elevation: none;
  --goto-menu-presence-available-color: var(--goto-text-04);
  --goto-menu-presence-busy-color: var(--goto-text-04);
  --goto-menu-presence-away-color: var(--goto-text-04);
  --goto-menu-presence-dnd-color: var(--goto-text-04);
  --goto-menu-presence-offline-color: var(--goto-text-04);
  --goto-button-neutral-inverse-border: var(--goto-inverse-border);
  --goto-button-neutral-inverse-background-hover: var(--goto-inverse-hover-01);
  --goto-button-neutral-inverse-background-active: var(--goto-inverse-pressed-01);
  --goto-snackbar-content-color: var(--goto-text-07);
  --goto-snackbar-background: var(--goto-neutral);
  --goto-progress-background-inverse: var(--goto-inverse-ui-05);
  --goto-switch-background-disabled: var(--goto-disabled-02);
  --goto-switch-checked-background-disabled: var(--goto-disabled-02);
  --goto-switch-knob-disabled: var(--goto-disabled-04);
  --goto-tile-background: var(--goto-interactive-01);
  --goto-tile-border: var(--goto-interactive-01);
  --goto-tile-border-secondary: var(--goto-interactive-01);
  --goto-tile-background-selected: var(--goto-interactive-01);
  --goto-tile-background-hover: var(--goto-interactive-01);
  --goto-tile-background-active: var(--goto-interactive-01);
  --goto-tile-background-secondary: var(--goto-interactive-02);
  --goto-tile-background-secondary-hover: var(--goto-hover-secondary);
  --goto-tile-background-secondary-active: var(--goto-pressed-secondary);
  --goto-tile-background-disabled: var(--goto-ui-01);
  --goto-tile-border-disabled: var(--goto-border);
  --goto-option-background-selected: var(--goto-interactive-01);
  --goto-option-color-selected: var(--goto-text-04);
  --goto-option-icon-color-selected: var(--goto-text-04);
  --goto-option-background-hover: var(--goto-interactive-01);
  --goto-option-color-disabled: var(--goto-disabled-04);
  --goto-option-icon-color-disabled: var(--goto-disabled-04);
  --goto-tooltip-font: var(--goto-caption-default-01);
  --goto-avatar-neutral: #828E9E;
  --goto-avatar-secondary: rgba(107, 117, 130, 0.1);
  --goto-avatar-secondary-icon-color: #9AA8BB;
  --goto-avatar-group-max-hint: #6B7582;
  --goto-avatar-primary-01: #009EBA;
  --goto-avatar-primary-02: #007FA3;
  --goto-avatar-primary-03: #0F5980;
  --goto-avatar-primary-04: #24A859;
  --goto-avatar-primary-05: #248A70;
  --goto-avatar-primary-06: #186349;
  --goto-avatar-primary-07: #9E9600;
  --goto-avatar-primary-08: #898F37;
  --goto-avatar-primary-09: #606408;
  --goto-avatar-primary-10: #C48800;
  --goto-avatar-primary-11: #947456;
  --goto-avatar-primary-12: #994D03;
  --goto-avatar-primary-13: #D46555;
  --goto-avatar-primary-14: #A3586D;
  --goto-avatar-primary-15: #962A43;
  --goto-avatar-primary-16: #B2399F;
  --goto-avatar-primary-17: #8168A8;
  --goto-avatar-primary-18: #6C3699;
  --goto-border: rgba(76, 83, 93, 0.24);
  --goto-avatar-disabled-color: rgba(154, 168, 187, 0.8);
  --goto-danger-01: #E02D52;
  --goto-danger-02: rgba(253, 76, 111, 0.08);
  --goto-danger-03: rgba(224, 45, 82, 0.1);
  --goto-disabled-01: rgba(37, 40, 45, 0.06);
  --goto-disabled-02: rgba(154, 168, 187, 0.16);
  --goto-disabled-03: rgba(37, 40, 45, 0.36);
  --goto-disabled-04: rgba(37, 40, 45, 0.24);
  --goto-disabled-05: #FFFFFF;
  --goto-experience-badge-assist: #29969D;
  --goto-experience-badge-customer: #FD4C6F;
  --goto-experience-badge-meeting: #F68D2E;
  --goto-experience-badge-message: #4090FF;
  --goto-experience-badge-voice: #00AA6E;
  --goto-experience-badge-training: #992977;
  --goto-experience-badge-webinar: #00C0F3;
  --goto-experience-badge-gotoresolve: #7D33FF;
  --goto-field-01: rgba(76, 83, 93, 0.24);
  --goto-field-02: rgba(76, 83, 93, 0.48);
  --goto-field-03: rgba(76, 83, 93, 0.16);
  --goto-field-04: #FFFFFF;
  --goto-focus-error: #A12E45;
  --goto-focus-success: #166549;
  --goto-highlight-error: 0 0 0 5px rgba(253, 76, 111, 0.24);
  --goto-highlight-success: 0 0 0 5px rgba(0, 204, 133, 0.24);
  --goto-highlight-error-small: 0 0 0 2px rgba(253, 76, 111, 0.24);
  --goto-highlight-success-small: 0 0 0 2px rgba(0, 204, 133, 0.24);
  --goto-hover-01: rgba(217, 233, 255, 0.44);
  --goto-hover-02: rgba(154, 168, 187, 0.32);
  --goto-hover-danger: #a12e48;
  --goto-hover-primary: #004FBD;
  --goto-hover-secondary: rgba(128, 181, 255, 0.12);
  --goto-hover-success: #166549;
  --goto-hover-tertiary: rgba(128, 181, 255, 0.12);
  --goto-icon-01: #006AFF;
  --goto-icon-02: #FFFFFF;
  --goto-icon-03: #4C535D;
  --goto-icon-04: rgba(37, 40, 45, 0.67);
  --goto-icon-05: #FFFFFF;
  --goto-information-01: #006AFF;
  --goto-information-02: rgba(64, 144, 255, 0.08);
  --goto-information-03: rgba(0, 106, 255, 0.1);
  --goto-interactive-01: #006AFF;
  --goto-interactive-02: transparent;
  --goto-interactive-03: #006AFF;
  --goto-inverse-01: #25282D;
  --goto-inverse-02: #FFFFFF;
  --goto-inverse-border: rgba(255, 255, 255, 0.24);
  --goto-inverse-disabled: rgba(255, 255, 255, 0.36);
  --goto-inverse-hover-01: rgba(128, 181, 255, 0.12);
  --goto-inverse-focus: #80B5FF;
  --goto-inverse-interactive-01: #4090FF;
  --goto-inverse-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
  --goto-inverse-pressed-01: rgba(128, 181, 255, 0.24);
  --goto-inverse-ui-05: rgba(255, 255, 255, 0.24);
  --goto-orange-01: #F68D2E;
  --goto-orange-03: rgba(246, 141, 46, 0.1);
  --goto-overlay-01: rgba(37, 40, 45, 0.6);
  --goto-presence-available: #00AA6E;
  --goto-presence-away: #FFCB00;
  --goto-presence-busy: #E02D52;
  --goto-presence-dnd: #003989;
  --goto-presence-offline: rgba(37, 40, 45, 0.67);
  --goto-pressed-01: rgba(217, 233, 255, 0.8);
  --goto-pressed-02: rgba(154, 168, 187, 0.48);
  --goto-pressed-danger: #88152f;
  --goto-pressed-primary: #003989;
  --goto-pressed-secondary: rgba(128, 181, 255, 0.24);
  --goto-pressed-success: #184f3b;
  --goto-pressed-tertiary: rgba(128, 181, 255, 0.24);
  --goto-purple-01: #7B44E4;
  --goto-purple-03: rgba(155, 102, 255, 0.1);
  --goto-success-01: #008858;
  --goto-success-02: rgba(0, 170, 110, 0.08);
  --goto-success-03: rgba(0, 136, 88, 0.1);
  --goto-text-01: #25282D;
  --goto-text-02: rgba(37, 40, 45, 0.67);
  --goto-text-03: rgba(37, 40, 45, 0.36);
  --goto-text-04: #FFFFFF;
  --goto-text-05: rgba(37, 40, 45, 0.67);
  --goto-text-06: #FFFFFF;
  --goto-text-07: rgba(255, 255, 255, 0.7);
  --goto-text-error-01: #E02D52;
  --goto-text-error-02: #A12E45;
  --goto-text-info: #004FBD;
  --goto-text-neutral: #25282D;
  --goto-text-success-01: #008858;
  --goto-text-success-02: #166549;
  --goto-text-warning-01: #D9AD00;
  --goto-text-warning-02: #8C4400;
  --goto-warning-01: #D9AD00;
  --goto-warning-02: rgba(255, 203, 0, 0.08);
  --goto-warning-03: rgba(255, 203, 0, 0.1);
  --goto-ui-01: #FFFFFF;
  --goto-ui-02: rgba(76, 83, 93, 0.24);
  --goto-ui-03: #B3BFCF;
  --goto-ui-04: rgba(37, 40, 45, 0.08);
  --goto-ui-05: rgba(154, 168, 187, 0.16);
  --goto-ui-06: #FFFFFF;
  --goto-ui-background: #FFFFFF;
  --goto-ui-base-01: #F0F2F5;
  --goto-ui-base-02: #E0E4EA;
  --goto-focus: #004FBD;
  --goto-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
  --goto-highlight-base: rgba(64, 144, 255, 0.24);
  --goto-highlight-small: 0 0 0 2px rgba(64, 144, 255, 0.24);
  --goto-link: #006AFF;
  --goto-neutral: #25282D;
  --goto-neutral-03: rgba(107, 117, 130, 0.1);
  --goto-contextual-menu-background-color: rgba(255, 255, 255, 0.8);
  --goto-toolbar-background-color: #F0F2F5;
  --goto-toolbar-hover-background-color: #DEE4Ec;
  --goto-toolbar-pressed-background-color: #006AFF;
  --goto-toolbar-disabled-background-color: rgba(154, 168, 187, 0.16);
  --goto-toolbar-disabled-icon-color: rgba(37, 40, 45, 0.24);
  --goto-avatar-color-00: #009eba;
  --goto-avatar-color-01: #007fa3;
  --goto-avatar-color-02: #0f5980;
  --goto-avatar-color-10: #24a859;
  --goto-avatar-color-11: #248a70;
  --goto-avatar-color-12: #186349;
  --goto-avatar-color-20: #9e9600;
  --goto-avatar-color-21: #898f37;
  --goto-avatar-color-22: #606408;
  --goto-avatar-color-30: #c48800;
  --goto-avatar-color-31: #947456;
  --goto-avatar-color-32: #994d03;
  --goto-avatar-color-40: #d46555;
  --goto-avatar-color-41: #a3586d;
  --goto-avatar-color-42: #962a43;
  --goto-avatar-color-50: #b2399f;
  --goto-avatar-color-51: #8168a8;
  --goto-avatar-color-52: #6c3699;
  --goto-avatar-color-primary: rgba(42, 50, 56, 0.5);
  --goto-avatar-color-secondary: rgba(42, 50, 56, 0.1);
  --goto-background-color-default: white;
  --goto-background-color-secondary: #f2f6f7;
  --goto-badge-color-assist: #29969d;
  --goto-badge-color-audio: #a5941e;
  --goto-badge-color-custom: black;
  --goto-badge-color-customer: #fd4c6f;
  --goto-badge-color-disabled: rgba(0, 0, 0, 0.3);
  --goto-badge-color-files: rgba(70, 91, 107, 0.7);
  --goto-badge-color-gotoresolve: #7d33ff;
  --goto-badge-color-meeting: #f68d2e;
  --goto-badge-color-message: #4090ff;
  --goto-badge-color-training: #992977;
  --goto-badge-color-voice: #00aa6e;
  --goto-badge-color-webinar: #00c0f3;
  --goto-blue-100: #D9E9FF;
  --goto-blue-200: #BFDAFF;
  --goto-blue-300: #80B5FF;
  --goto-blue-400: #4090FF;
  --goto-blue-500: #006AFF;
  --goto-blue-600: #004FBD;
  --goto-blue-700: #0f3599;
  --goto-border-color-brand: #1b8756;
  --goto-border-color-danger: #d33a61;
  --goto-border-color-default: rgba(88, 121, 143, 0.5);
  --goto-border-color-inverted: rgba(152, 182, 201, 0.5);
  --goto-border-color-persistent: rgba(88, 121, 143, 0.5);
  --goto-border-color-secondary: #f2f6f7;
  --goto-border-color-success: #1b8756;
  --goto-border-color-warning: #a5941e;
  --goto-brand-100: #d1f6cf;
  --goto-brand-200: #a1e8a5;
  --goto-brand-300: #53ce73;
  --goto-brand-400: #2ba95c;
  --goto-brand-500: #1b8756;
  --goto-brand-600: #146459;
  --goto-brand-700: #004f49;
  --goto-focus-border-color-danger: white;
  --goto-focus-border-color-default: white;
  --goto-focus-border-color-persistent: black;
  --goto-focus-border-color-success: white;
  --goto-focus-color-highlight-danger: #a52251;
  --goto-focus-color-highlight-default: black;
  --goto-focus-color-highlight-persistent: white;
  --goto-focus-color-highlight-success: #146459;
  --goto-gradient-color-skeleton: linear-gradient(90deg, rgba(37, 40, 45, 0) 0%, rgba(37, 40, 45, 0.1) 50%, rgba(37, 40, 45, 0) 100%);
  --goto-green-100: #D9FFF2;
  --goto-green-200: #80FFD2;
  --goto-green-300: #00CC85;
  --goto-green-400: #00AA6E;
  --goto-green-500: #008858;
  --goto-green-600: #166549;
  --goto-green-700: #004f49;
  --goto-icon-color-brand-default: #1b8756;
  --goto-icon-color-brand-persistent: #53ce73;
  --goto-icon-color-danger: #d33a61;
  --goto-icon-color-default: black;
  --goto-icon-color-disabled: rgba(0, 0, 0, 0.3);
  --goto-icon-color-inverted: white;
  --goto-icon-color-persistent: white;
  --goto-icon-color-persistent-disabled: rgba(255, 255, 255, 0.3);
  --goto-icon-color-secondary: rgba(42, 50, 56, 0.7);
  --goto-icon-color-success: #1b8756;
  --goto-icon-color-warning: #a5941e;
  --goto-interactive-color-brand-default: #1b8756;
  --goto-interactive-color-brand-hover: #146459;
  --goto-interactive-color-brand-pressed: #004f49;
  --goto-interactive-color-danger-default: #d33a61;
  --goto-interactive-color-danger-hover: #a52251;
  --goto-interactive-color-danger-pressed: #801248;
  --goto-interactive-color-disabled: rgba(0, 0, 0, 0.1);
  --goto-interactive-color-neutral-default: #f2f6f7;
  --goto-interactive-color-neutral-hover: #d9e3e9;
  --goto-interactive-color-neutral-pressed: #c3d4de;
  --goto-interactive-color-persistent-default: black;
  --goto-interactive-color-persistent-hover: #2a3238;
  --goto-interactive-color-persistent-pressed: #3d4852;
  --goto-interactive-color-primary-default: black;
  --goto-interactive-color-primary-hover: #2a3238;
  --goto-interactive-color-primary-pressed: #3d4852;
  --goto-interactive-color-secondary-default: #58798f;
  --goto-interactive-color-secondary-hover: rgba(88, 121, 143, 0.1);
  --goto-interactive-color-secondary-pressed: rgba(88, 121, 143, 0.3);
  --goto-interactive-color-success-default: #1b8756;
  --goto-interactive-color-success-hover: #146459;
  --goto-interactive-color-success-pressed: #004f49;
  --goto-neutral-000: #FFFFFF;
  --goto-neutral-050: #F7F8Fa;
  --goto-neutral-100: #F0F2F5;
  --goto-neutral-200: #E0E4EA;
  --goto-neutral-300: #9AA8BB;
  --goto-neutral-400: #6B7582;
  --goto-neutral-500: #4C535D;
  --goto-neutral-600: #25282D;
  --goto-neutral-700: #000000;
  --goto-neutral-800: #2a3238;
  --goto-neutral-900: black;
  --goto-orange-100: #FEEDDE;
  --goto-orange-200: #FFC48C;
  --goto-orange-300: #F68D2E;
  --goto-orange-400: #DB781C;
  --goto-orange-500: #B35F11;
  --goto-orange-600: #8C4400;
  --goto-orange-700: #703c0a;
  --goto-purple-100: #E6D9FF;
  --goto-purple-200: #D5BFFF;
  --goto-purple-300: #AC80FF;
  --goto-purple-400: #9B66FF;
  --goto-purple-500: #7B44E4;
  --goto-purple-600: #6739BF;
  --goto-purple-700: #321c9c;
  --goto-red-100: #FEE2E8;
  --goto-red-200: #FABCC8;
  --goto-red-300: #FD94A9;
  --goto-red-400: #FD4C6F;
  --goto-red-500: #E02D52;
  --goto-red-600: #A12E45;
  --goto-red-700: #801248;
  --goto-scrim-color: rgba(42, 50, 56, 0.7);
  --goto-surface-color-brand-default: #1b8756;
  --goto-surface-color-brand-secondary: rgba(27, 135, 86, 0.1);
  --goto-surface-color-danger-default: #d33a61;
  --goto-surface-color-danger-secondary: rgba(211, 58, 97, 0.1);
  --goto-surface-color-default: white;
  --goto-surface-color-default-semitransparent: rgba(255, 255, 255, 0.7);
  --goto-surface-color-inverted: black;
  --goto-surface-color-persistent: black;
  --goto-surface-color-secondary: #f2f6f7;
  --goto-surface-color-success-default: #1b8756;
  --goto-surface-color-success-secondary: rgba(27, 135, 86, 0.1);
  --goto-surface-color-tertiary: rgba(88, 121, 143, 0.5);
  --goto-surface-color-utility-orange: rgba(246, 141, 46, 0.1);
  --goto-surface-color-utility-purple: rgba(194, 164, 255, 0.1);
  --goto-surface-color-warning-default: #f2dd06;
  --goto-surface-color-warning-secondary: rgba(242, 221, 6, 0.1);
  --goto-type-color-brand-default: #1b8756;
  --goto-type-color-brand-persistent: #53ce73;
  --goto-type-color-danger: #d33a61;
  --goto-type-color-default: black;
  --goto-type-color-disabled: rgba(0, 0, 0, 0.3);
  --goto-type-color-inverted: white;
  --goto-type-color-persistent: white;
  --goto-type-color-persistent-disabled: rgba(255, 255, 255, 0.3);
  --goto-type-color-secondary: rgba(42, 50, 56, 0.7);
  --goto-type-color-secondary-inverted: rgba(152, 182, 201, 0.7);
  --goto-type-color-success: #1b8756;
  --goto-type-color-warning: #a5941e;
  --goto-yellow-100: #FFF7D9;
  --goto-yellow-200: #FFE88C;
  --goto-yellow-300: #FFCB00;
  --goto-yellow-400: #D9AD00;
  --goto-yellow-500: #B38F00;
  --goto-yellow-600: #997A00;
  --goto-yellow-700: #685714;
  --goto-neutral-550: #383D45;
  --goto-neutral-450: #5B646F;
  --goto-neutral-350: #828E9E;
  --goto-neutral-250: #B3BFCF;
  --goto-neutral-150: #DEE4Ec;
}
:root .theme-light {
  --goto-blur-100: 4px;
  --goto-blur-200: 12px;
  --goto-blur-300: 24px;
  --goto-blur-400: 36px;
  --goto-blur-large: 50px;
  --goto-blur-medium: 30px;
  --goto-blur-small: 10px;
  --goto-blur-xlarge: 70px;
  --goto-elevation-100: 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.04);
  --goto-elevation-200: 0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.08), 0 1px 10px 0 rgba(0, 0, 0, 0.04);
  --goto-elevation-300: 0 5px 5px -3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.08), 0 3px 14px 2px rgba(0, 0, 0, 0.04);
  --goto-elevation-400: 0 8px 10px -5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.08), 0 6px 30px 5px rgba(0, 0, 0, 0.04);
  --goto-elevation-large: 0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2);
  --goto-elevation-medium: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
  --goto-elevation-none: none;
  --goto-elevation-small: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
  --goto-elevation-xlarge: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
  --goto-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --goto-font-family-mono: Menlo, Consolas, Monaco, 'Liberation Mono', 'Lucida Console', monospace;
  --goto-menu-width: 240px;
  --goto-topbar-background: var(--goto-ui-base-01);
  --goto-topbar-border: var(--goto-border);
  --goto-navigation-rail-background: var(--goto-ui-base-01);
  --goto-navigation-rail-border-right: var(--goto-border);
  --goto-navigation-rail-item-hover: var(--goto-hover-tertiary);
  --goto-navigation-rail-item-active: var(--goto-pressed-tertiary);
  --goto-navigation-rail-item-selected: transparent;
  --goto-navigation-rail-item-disabled: transparent;
  --goto-navigation-rail-icon: var(--goto-text-02);
  --goto-navigation-rail-icon-selected: var(--goto-icon-01);
  --goto-navigation-rail-icon-disabled: var(--goto-text-03);
  --goto-navigation-rail-text: var(--goto-text-02);
  --goto-navigation-rail-text-selected: var(--goto-text-02);
  --goto-navigation-rail-text-disabled: var(--goto-text-03);
  --goto-navigation-rail-focus: var(--goto-focus);
  --goto-navigation-rail-highlight: var(--goto-highlight);
  --goto-avatar-24: 700 0.625rem/0.875rem var(--goto-font-family);
  --goto-avatar-30: 700 0.75rem/1.065rem var(--goto-font-family);
  --goto-avatar-36: 700 0.875rem/0.9975rem var(--goto-font-family);
  --goto-avatar-48: 700 1.25rem/1.5rem var(--goto-font-family);
  --goto-avatar-64: 700 1.667rem/1.93372rem var(--goto-font-family);
  --goto-avatar-80: 700 2.25rem/2.6775rem var(--goto-font-family);
  --goto-avatar-180: 700 5.063rem/6.02497rem var(--goto-font-family);
  --goto-code-text-small: 400 0.75rem/0.9975rem var(--goto-font-family-mono);
  --goto-code-text-medium: 400 0.875rem/1.225rem var(--goto-font-family-mono);
  --goto-body-small: 400 0.875rem/1.5rem var(--goto-font-family);
  --goto-body-medium: 400 1rem/1.5rem var(--goto-font-family);
  --goto-body-large: 400 1.125rem/1.5rem var(--goto-font-family);
  --goto-body-small-semibold: 600 0.875rem/1.225rem var(--goto-font-family);
  --goto-body-medium-semibold: 600 1rem/1.4rem var(--goto-font-family);
  --goto-button-text-small: 600 0.75rem/1.05rem var(--goto-font-family);
  --goto-button-text-medium: 600 0.875rem/1.225rem var(--goto-font-family);
  --goto-button-text-large: 600 1rem/1.575rem var(--goto-font-family);
  --goto-button-text-xlarge: 600 1.125rem/1.575rem var(--goto-font-family);
  --goto-caption-default-01: 400 0.75rem/1.05rem var(--goto-font-family);
  --goto-caption-default-02: 600 0.75rem/1.05rem var(--goto-font-family);
  --goto-caption-small-01: 400 0.625rem/0.875rem var(--goto-font-family);
  --goto-caption-small-02: 600 0.625rem/0.875rem var(--goto-font-family);
  --goto-heading-small: 600 1.25rem/1.5rem var(--goto-font-family);
  --goto-heading-medium: 600 1.75rem/2rem var(--goto-font-family);
  --goto-heading-large: 700 2.25rem/2.5rem var(--goto-font-family);
  --goto-heading-xlarge: 700 3rem/3.25rem var(--goto-font-family);
  --goto-avatar-large: 700 1.25rem/1.5rem var(--goto-font-family);
  --goto-avatar-medium: 700 0.875rem/1.25rem var(--goto-font-family);
  --goto-avatar-small: 700 0.75rem/1rem var(--goto-font-family);
  --goto-avatar-xlarge: 700 1.625rem/2rem var(--goto-font-family);
  --goto-avatar-xsmall: 700 0.625rem/1rem var(--goto-font-family);
  --goto-avatar-xxlarge: 700 2.25rem/3rem var(--goto-font-family);
  --goto-avatar-xxxlarge: 700 5rem/6.25rem var(--goto-font-family);
  --goto-body-large-strong: 600 1.125rem/1.5rem var(--goto-font-family);
  --goto-body-medium-strong: 600 1rem/1.5rem var(--goto-font-family);
  --goto-body-small-strong: 600 0.875rem/1.5rem var(--goto-font-family);
  --goto-button-large: 600 1rem/1.5rem var(--goto-font-family);
  --goto-button-medium: 600 0.875rem/1.5rem var(--goto-font-family);
  --goto-button-small: 600 0.75rem/1.25rem var(--goto-font-family);
  --goto-button-xlarge: 600 1.125rem/1.5rem var(--goto-font-family);
  --goto-caption-medium: 400 0.75rem/1.25rem var(--goto-font-family);
  --goto-caption-medium-strong: 600 0.75rem/1.25rem var(--goto-font-family);
  --goto-caption-small: 400 0.625rem/1rem var(--goto-font-family);
  --goto-caption-small-strong: 600 0.625rem/1rem var(--goto-font-family);
  --goto-code-medium: 400 0.875rem/1.5rem var(--goto-font-family-mono);
  --goto-code-small: 400 0.75rem/1.25rem var(--goto-font-family-mono);
  --goto-layout-00: 0;
  --goto-layout-01: 16px;
  --goto-layout-02: 24px;
  --goto-layout-03: 32px;
  --goto-layout-04: 48px;
  --goto-layout-05: 64px;
  --goto-layout-06: 96px;
  --goto-layout-07: 160px;
  --goto-meeting: #F68D2E;
  --goto-room: #F68D2E;
  --goto-connect: #C4D600;
  --goto-webinar: #00C0F3;
  --goto-assist: #24658a;
  --goto-resolve: #7D33FF;
  --goto-training: #992977;
  --goto-open-voice: #a28bc4;
  --goto-jive: #cfe012;
  --goto-spacing-00: 0rem;
  --goto-spacing-01: 4px;
  --goto-spacing-02: 8px;
  --goto-spacing-03: 12px;
  --goto-spacing-04: 16px;
  --goto-spacing-05: 20px;
  --goto-spacing-06: 24px;
  --goto-spacing-07: 32px;
  --goto-spacing-08: 40px;
  --goto-spacing-09: 48px;
  --goto-spacing-10: 3.5rem;
  --goto-spacing-11: 4rem;
  --goto-transition-dialog-in: visibility 0s linear 0s, opacity 250ms 0s, transform 250ms;
  --goto-transition-dialog-out: visibility 0s linear 250ms, opacity 250ms 0s, transform 250ms;
  --goto-radius-circle: 1000px;
  --goto-radius-large: 12px;
  --goto-radius-medium: 8px;
  --goto-radius-none: 0px;
  --goto-radius-small: 4px;
  --goto-radius-xlarge: 16px;
  --goto-checkbox-checked-hover: var(--goto-hover-primary);
  --goto-checkbox-checked-pressed: var(--goto-pressed-primary);
  --goto-badge-background-disabled: var(--goto-disabled-02);
  --goto-badge-icon-disabled: var(--goto-disabled-04);
  --goto-alert-background: var(--goto-information-02);
  --goto-alert-border: var(--goto-interactive-01);
  --goto-chip-background: var(--goto-disabled-02);
  --goto-chip-background-selected: var(--goto-interactive-01);
  --goto-chip-background-selected-hover: var(--goto-hover-primary);
  --goto-chip-background-selected-active: var(--goto-pressed-primary);
  --goto-search-field-background: var(--goto-disabled-02);
  --goto-search-field-background-active: transparent;
  --goto-search-field-border-hover: var(--goto-disabled-02);
  --goto-search-field-icon-disabled: var(--goto-text-03);
  --goto-search-field-text-disabled: var(--goto-text-01);
  --goto-search-field-background-disabled: var(--goto-disabled-02);
  --goto-search-field-opacity-disabled: var(--disabled-opacity);
  --goto-search-field-clear-icon-background: var(--goto-text-02);
  --goto-select-inline-border: transparent;
  --goto-select-inline-font: var(--goto-caption-default-02);
  --goto-select-inline-border-hover: var(--goto-field-01);
  --goto-select-inline-background-hover: var(--goto-hover-secondary);
  --goto-select-inline-border-active: var(--goto-pressed-secondary);
  --goto-select-inline-background-active: var(--goto-pressed-secondary);
  --goto-round-button-icon-color: var(--goto-icon-01);
  --goto-round-button-border-success: var(--goto-success-01);
  --goto-round-button-border-danger: var(--goto-danger-01);
  --goto-tabs-indicator-background: var(--goto-interactive-01);
  --goto-skeleton-gradient: linear-gradient(90deg, transparent, var(--goto-disabled-01), transparent);
  --goto-input-success-border: var(--goto-success-01);
  --goto-input-danger-border: var(--goto-danger-01);
  --goto-nav-drawer-item-background-selected: var(--goto-interactive-01);
  --goto-nav-drawer-item-icon-color: var(--goto-text-02);
  --goto-nav-drawer-item-icon-color-selected: var(--goto-text-04);
  --goto-avatar-background-secondary-disabled: var(--goto-inverse-ui-05);
  --goto-avatar-color-secondary-disabled: var(--goto-disabled-04);
  --goto-avatar-border-secondary-disabled: 1px solid var(--goto-disabled-04);
  --goto-popover-border-color: var(--goto-ui-02);
  --goto-popover-elevation: var(--goto-elevation-300);
  --goto-empty-state-icon-color: var(--goto-disabled-04);
  --goto-radio-button-border-disabled: var(--goto-border);
  --goto-menu-background: inherit;
  --goto-menu-background-hover: var(--goto-interactive-01);
  --goto-menu-color-disabled: var(--goto-text-03);
  --goto-menu-color-hover: var(--goto-text-04);
  --goto-menu-icon-color: var(--goto-text-02);
  --goto-menu-elevation: none;
  --goto-menu-presence-available-color: var(--goto-text-04);
  --goto-menu-presence-busy-color: var(--goto-text-04);
  --goto-menu-presence-away-color: var(--goto-text-04);
  --goto-menu-presence-dnd-color: var(--goto-text-04);
  --goto-menu-presence-offline-color: var(--goto-text-04);
  --goto-button-neutral-inverse-border: var(--goto-inverse-border);
  --goto-button-neutral-inverse-background-hover: var(--goto-inverse-hover-01);
  --goto-button-neutral-inverse-background-active: var(--goto-inverse-pressed-01);
  --goto-snackbar-content-color: var(--goto-text-07);
  --goto-snackbar-background: var(--goto-neutral);
  --goto-progress-background-inverse: var(--goto-inverse-ui-05);
  --goto-switch-background-disabled: var(--goto-disabled-02);
  --goto-switch-checked-background-disabled: var(--goto-disabled-02);
  --goto-switch-knob-disabled: var(--goto-disabled-04);
  --goto-tile-background: var(--goto-interactive-01);
  --goto-tile-border: var(--goto-interactive-01);
  --goto-tile-border-secondary: var(--goto-interactive-01);
  --goto-tile-background-selected: var(--goto-interactive-01);
  --goto-tile-background-hover: var(--goto-interactive-01);
  --goto-tile-background-active: var(--goto-interactive-01);
  --goto-tile-background-secondary: var(--goto-interactive-02);
  --goto-tile-background-secondary-hover: var(--goto-hover-secondary);
  --goto-tile-background-secondary-active: var(--goto-pressed-secondary);
  --goto-tile-background-disabled: var(--goto-ui-01);
  --goto-tile-border-disabled: var(--goto-border);
  --goto-option-background-selected: var(--goto-interactive-01);
  --goto-option-color-selected: var(--goto-text-04);
  --goto-option-icon-color-selected: var(--goto-text-04);
  --goto-option-background-hover: var(--goto-interactive-01);
  --goto-option-color-disabled: var(--goto-disabled-04);
  --goto-option-icon-color-disabled: var(--goto-disabled-04);
  --goto-tooltip-font: var(--goto-caption-default-01);
  --goto-avatar-neutral: #828E9E;
  --goto-avatar-secondary: rgba(107, 117, 130, 0.1);
  --goto-avatar-secondary-icon-color: #9AA8BB;
  --goto-avatar-group-max-hint: #6B7582;
  --goto-avatar-primary-01: #009EBA;
  --goto-avatar-primary-02: #007FA3;
  --goto-avatar-primary-03: #0F5980;
  --goto-avatar-primary-04: #24A859;
  --goto-avatar-primary-05: #248A70;
  --goto-avatar-primary-06: #186349;
  --goto-avatar-primary-07: #9E9600;
  --goto-avatar-primary-08: #898F37;
  --goto-avatar-primary-09: #606408;
  --goto-avatar-primary-10: #C48800;
  --goto-avatar-primary-11: #947456;
  --goto-avatar-primary-12: #994D03;
  --goto-avatar-primary-13: #D46555;
  --goto-avatar-primary-14: #A3586D;
  --goto-avatar-primary-15: #962A43;
  --goto-avatar-primary-16: #B2399F;
  --goto-avatar-primary-17: #8168A8;
  --goto-avatar-primary-18: #6C3699;
  --goto-border: rgba(76, 83, 93, 0.24);
  --goto-avatar-disabled-color: rgba(154, 168, 187, 0.8);
  --goto-danger-01: #E02D52;
  --goto-danger-02: rgba(253, 76, 111, 0.08);
  --goto-danger-03: rgba(224, 45, 82, 0.1);
  --goto-disabled-01: rgba(37, 40, 45, 0.06);
  --goto-disabled-02: rgba(154, 168, 187, 0.16);
  --goto-disabled-03: rgba(37, 40, 45, 0.36);
  --goto-disabled-04: rgba(37, 40, 45, 0.24);
  --goto-disabled-05: #FFFFFF;
  --goto-experience-badge-assist: #29969D;
  --goto-experience-badge-customer: #FD4C6F;
  --goto-experience-badge-meeting: #F68D2E;
  --goto-experience-badge-message: #4090FF;
  --goto-experience-badge-voice: #00AA6E;
  --goto-experience-badge-training: #992977;
  --goto-experience-badge-webinar: #00C0F3;
  --goto-experience-badge-gotoresolve: #7D33FF;
  --goto-field-01: rgba(76, 83, 93, 0.24);
  --goto-field-02: rgba(76, 83, 93, 0.48);
  --goto-field-03: rgba(76, 83, 93, 0.16);
  --goto-field-04: #FFFFFF;
  --goto-focus-error: #A12E45;
  --goto-focus-success: #166549;
  --goto-highlight-error: 0 0 0 5px rgba(253, 76, 111, 0.24);
  --goto-highlight-success: 0 0 0 5px rgba(0, 204, 133, 0.24);
  --goto-highlight-error-small: 0 0 0 2px rgba(253, 76, 111, 0.24);
  --goto-highlight-success-small: 0 0 0 2px rgba(0, 204, 133, 0.24);
  --goto-hover-01: rgba(217, 233, 255, 0.44);
  --goto-hover-02: rgba(154, 168, 187, 0.32);
  --goto-hover-danger: #a12e48;
  --goto-hover-primary: #004FBD;
  --goto-hover-secondary: rgba(128, 181, 255, 0.12);
  --goto-hover-success: #166549;
  --goto-hover-tertiary: rgba(128, 181, 255, 0.12);
  --goto-icon-01: #006AFF;
  --goto-icon-02: #FFFFFF;
  --goto-icon-03: #4C535D;
  --goto-icon-04: rgba(37, 40, 45, 0.67);
  --goto-icon-05: #FFFFFF;
  --goto-information-01: #006AFF;
  --goto-information-02: rgba(64, 144, 255, 0.08);
  --goto-information-03: rgba(0, 106, 255, 0.1);
  --goto-interactive-01: #006AFF;
  --goto-interactive-02: transparent;
  --goto-interactive-03: #006AFF;
  --goto-inverse-01: #25282D;
  --goto-inverse-02: #FFFFFF;
  --goto-inverse-border: rgba(255, 255, 255, 0.24);
  --goto-inverse-disabled: rgba(255, 255, 255, 0.36);
  --goto-inverse-hover-01: rgba(128, 181, 255, 0.12);
  --goto-inverse-focus: #80B5FF;
  --goto-inverse-interactive-01: #4090FF;
  --goto-inverse-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
  --goto-inverse-pressed-01: rgba(128, 181, 255, 0.24);
  --goto-inverse-ui-05: rgba(255, 255, 255, 0.24);
  --goto-orange-01: #F68D2E;
  --goto-orange-03: rgba(246, 141, 46, 0.1);
  --goto-overlay-01: rgba(37, 40, 45, 0.6);
  --goto-presence-available: #00AA6E;
  --goto-presence-away: #FFCB00;
  --goto-presence-busy: #E02D52;
  --goto-presence-dnd: #003989;
  --goto-presence-offline: rgba(37, 40, 45, 0.67);
  --goto-pressed-01: rgba(217, 233, 255, 0.8);
  --goto-pressed-02: rgba(154, 168, 187, 0.48);
  --goto-pressed-danger: #88152f;
  --goto-pressed-primary: #003989;
  --goto-pressed-secondary: rgba(128, 181, 255, 0.24);
  --goto-pressed-success: #184f3b;
  --goto-pressed-tertiary: rgba(128, 181, 255, 0.24);
  --goto-purple-01: #7B44E4;
  --goto-purple-03: rgba(155, 102, 255, 0.1);
  --goto-success-01: #008858;
  --goto-success-02: rgba(0, 170, 110, 0.08);
  --goto-success-03: rgba(0, 136, 88, 0.1);
  --goto-text-01: #25282D;
  --goto-text-02: rgba(37, 40, 45, 0.67);
  --goto-text-03: rgba(37, 40, 45, 0.36);
  --goto-text-04: #FFFFFF;
  --goto-text-05: rgba(37, 40, 45, 0.67);
  --goto-text-06: #FFFFFF;
  --goto-text-07: rgba(255, 255, 255, 0.7);
  --goto-text-error-01: #E02D52;
  --goto-text-error-02: #A12E45;
  --goto-text-info: #004FBD;
  --goto-text-neutral: #25282D;
  --goto-text-success-01: #008858;
  --goto-text-success-02: #166549;
  --goto-text-warning-01: #D9AD00;
  --goto-text-warning-02: #8C4400;
  --goto-warning-01: #D9AD00;
  --goto-warning-02: rgba(255, 203, 0, 0.08);
  --goto-warning-03: rgba(255, 203, 0, 0.1);
  --goto-ui-01: #FFFFFF;
  --goto-ui-02: rgba(76, 83, 93, 0.24);
  --goto-ui-03: #B3BFCF;
  --goto-ui-04: rgba(37, 40, 45, 0.08);
  --goto-ui-05: rgba(154, 168, 187, 0.16);
  --goto-ui-06: #FFFFFF;
  --goto-ui-background: #FFFFFF;
  --goto-ui-base-01: #F0F2F5;
  --goto-ui-base-02: #E0E4EA;
  --goto-focus: #004FBD;
  --goto-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
  --goto-highlight-base: rgba(64, 144, 255, 0.24);
  --goto-highlight-small: 0 0 0 2px rgba(64, 144, 255, 0.24);
  --goto-link: #006AFF;
  --goto-neutral: #25282D;
  --goto-neutral-03: rgba(107, 117, 130, 0.1);
  --goto-contextual-menu-background-color: rgba(255, 255, 255, 0.8);
  --goto-toolbar-background-color: #F0F2F5;
  --goto-toolbar-hover-background-color: #DEE4Ec;
  --goto-toolbar-pressed-background-color: #006AFF;
  --goto-toolbar-disabled-background-color: rgba(154, 168, 187, 0.16);
  --goto-toolbar-disabled-icon-color: rgba(37, 40, 45, 0.24);
  --goto-avatar-color-00: #009eba;
  --goto-avatar-color-01: #007fa3;
  --goto-avatar-color-02: #0f5980;
  --goto-avatar-color-10: #24a859;
  --goto-avatar-color-11: #248a70;
  --goto-avatar-color-12: #186349;
  --goto-avatar-color-20: #9e9600;
  --goto-avatar-color-21: #898f37;
  --goto-avatar-color-22: #606408;
  --goto-avatar-color-30: #c48800;
  --goto-avatar-color-31: #947456;
  --goto-avatar-color-32: #994d03;
  --goto-avatar-color-40: #d46555;
  --goto-avatar-color-41: #a3586d;
  --goto-avatar-color-42: #962a43;
  --goto-avatar-color-50: #b2399f;
  --goto-avatar-color-51: #8168a8;
  --goto-avatar-color-52: #6c3699;
  --goto-avatar-color-primary: rgba(42, 50, 56, 0.5);
  --goto-avatar-color-secondary: rgba(42, 50, 56, 0.1);
  --goto-background-color-default: white;
  --goto-background-color-secondary: #f2f6f7;
  --goto-badge-color-assist: #29969d;
  --goto-badge-color-audio: #a5941e;
  --goto-badge-color-custom: black;
  --goto-badge-color-customer: #fd4c6f;
  --goto-badge-color-disabled: rgba(0, 0, 0, 0.3);
  --goto-badge-color-files: rgba(70, 91, 107, 0.7);
  --goto-badge-color-gotoresolve: #7d33ff;
  --goto-badge-color-meeting: #f68d2e;
  --goto-badge-color-message: #4090ff;
  --goto-badge-color-training: #992977;
  --goto-badge-color-voice: #00aa6e;
  --goto-badge-color-webinar: #00c0f3;
  --goto-blue-100: #D9E9FF;
  --goto-blue-200: #BFDAFF;
  --goto-blue-300: #80B5FF;
  --goto-blue-400: #4090FF;
  --goto-blue-500: #006AFF;
  --goto-blue-600: #004FBD;
  --goto-blue-700: #0f3599;
  --goto-border-color-brand: #1b8756;
  --goto-border-color-danger: #d33a61;
  --goto-border-color-default: rgba(88, 121, 143, 0.5);
  --goto-border-color-inverted: rgba(152, 182, 201, 0.5);
  --goto-border-color-persistent: rgba(88, 121, 143, 0.5);
  --goto-border-color-secondary: #f2f6f7;
  --goto-border-color-success: #1b8756;
  --goto-border-color-warning: #a5941e;
  --goto-brand-100: #d1f6cf;
  --goto-brand-200: #a1e8a5;
  --goto-brand-300: #53ce73;
  --goto-brand-400: #2ba95c;
  --goto-brand-500: #1b8756;
  --goto-brand-600: #146459;
  --goto-brand-700: #004f49;
  --goto-focus-border-color-danger: white;
  --goto-focus-border-color-default: white;
  --goto-focus-border-color-persistent: black;
  --goto-focus-border-color-success: white;
  --goto-focus-color-highlight-danger: #a52251;
  --goto-focus-color-highlight-default: black;
  --goto-focus-color-highlight-persistent: white;
  --goto-focus-color-highlight-success: #146459;
  --goto-gradient-color-skeleton: linear-gradient(90deg, rgba(37, 40, 45, 0) 0%, rgba(37, 40, 45, 0.1) 50%, rgba(37, 40, 45, 0) 100%);
  --goto-green-100: #D9FFF2;
  --goto-green-200: #80FFD2;
  --goto-green-300: #00CC85;
  --goto-green-400: #00AA6E;
  --goto-green-500: #008858;
  --goto-green-600: #166549;
  --goto-green-700: #004f49;
  --goto-icon-color-brand-default: #1b8756;
  --goto-icon-color-brand-persistent: #53ce73;
  --goto-icon-color-danger: #d33a61;
  --goto-icon-color-default: black;
  --goto-icon-color-disabled: rgba(0, 0, 0, 0.3);
  --goto-icon-color-inverted: white;
  --goto-icon-color-persistent: white;
  --goto-icon-color-persistent-disabled: rgba(255, 255, 255, 0.3);
  --goto-icon-color-secondary: rgba(42, 50, 56, 0.7);
  --goto-icon-color-success: #1b8756;
  --goto-icon-color-warning: #a5941e;
  --goto-interactive-color-brand-default: #1b8756;
  --goto-interactive-color-brand-hover: #146459;
  --goto-interactive-color-brand-pressed: #004f49;
  --goto-interactive-color-danger-default: #d33a61;
  --goto-interactive-color-danger-hover: #a52251;
  --goto-interactive-color-danger-pressed: #801248;
  --goto-interactive-color-disabled: rgba(0, 0, 0, 0.1);
  --goto-interactive-color-neutral-default: #f2f6f7;
  --goto-interactive-color-neutral-hover: #d9e3e9;
  --goto-interactive-color-neutral-pressed: #c3d4de;
  --goto-interactive-color-persistent-default: black;
  --goto-interactive-color-persistent-hover: #2a3238;
  --goto-interactive-color-persistent-pressed: #3d4852;
  --goto-interactive-color-primary-default: black;
  --goto-interactive-color-primary-hover: #2a3238;
  --goto-interactive-color-primary-pressed: #3d4852;
  --goto-interactive-color-secondary-default: #58798f;
  --goto-interactive-color-secondary-hover: rgba(88, 121, 143, 0.1);
  --goto-interactive-color-secondary-pressed: rgba(88, 121, 143, 0.3);
  --goto-interactive-color-success-default: #1b8756;
  --goto-interactive-color-success-hover: #146459;
  --goto-interactive-color-success-pressed: #004f49;
  --goto-neutral-000: #FFFFFF;
  --goto-neutral-050: #F7F8Fa;
  --goto-neutral-100: #F0F2F5;
  --goto-neutral-200: #E0E4EA;
  --goto-neutral-300: #9AA8BB;
  --goto-neutral-400: #6B7582;
  --goto-neutral-500: #4C535D;
  --goto-neutral-600: #25282D;
  --goto-neutral-700: #000000;
  --goto-neutral-800: #2a3238;
  --goto-neutral-900: black;
  --goto-orange-100: #FEEDDE;
  --goto-orange-200: #FFC48C;
  --goto-orange-300: #F68D2E;
  --goto-orange-400: #DB781C;
  --goto-orange-500: #B35F11;
  --goto-orange-600: #8C4400;
  --goto-orange-700: #703c0a;
  --goto-purple-100: #E6D9FF;
  --goto-purple-200: #D5BFFF;
  --goto-purple-300: #AC80FF;
  --goto-purple-400: #9B66FF;
  --goto-purple-500: #7B44E4;
  --goto-purple-600: #6739BF;
  --goto-purple-700: #321c9c;
  --goto-red-100: #FEE2E8;
  --goto-red-200: #FABCC8;
  --goto-red-300: #FD94A9;
  --goto-red-400: #FD4C6F;
  --goto-red-500: #E02D52;
  --goto-red-600: #A12E45;
  --goto-red-700: #801248;
  --goto-scrim-color: rgba(42, 50, 56, 0.7);
  --goto-surface-color-brand-default: #1b8756;
  --goto-surface-color-brand-secondary: rgba(27, 135, 86, 0.1);
  --goto-surface-color-danger-default: #d33a61;
  --goto-surface-color-danger-secondary: rgba(211, 58, 97, 0.1);
  --goto-surface-color-default: white;
  --goto-surface-color-default-semitransparent: rgba(255, 255, 255, 0.7);
  --goto-surface-color-inverted: black;
  --goto-surface-color-persistent: black;
  --goto-surface-color-secondary: #f2f6f7;
  --goto-surface-color-success-default: #1b8756;
  --goto-surface-color-success-secondary: rgba(27, 135, 86, 0.1);
  --goto-surface-color-tertiary: rgba(88, 121, 143, 0.5);
  --goto-surface-color-utility-orange: rgba(246, 141, 46, 0.1);
  --goto-surface-color-utility-purple: rgba(194, 164, 255, 0.1);
  --goto-surface-color-warning-default: #f2dd06;
  --goto-surface-color-warning-secondary: rgba(242, 221, 6, 0.1);
  --goto-type-color-brand-default: #1b8756;
  --goto-type-color-brand-persistent: #53ce73;
  --goto-type-color-danger: #d33a61;
  --goto-type-color-default: black;
  --goto-type-color-disabled: rgba(0, 0, 0, 0.3);
  --goto-type-color-inverted: white;
  --goto-type-color-persistent: white;
  --goto-type-color-persistent-disabled: rgba(255, 255, 255, 0.3);
  --goto-type-color-secondary: rgba(42, 50, 56, 0.7);
  --goto-type-color-secondary-inverted: rgba(152, 182, 201, 0.7);
  --goto-type-color-success: #1b8756;
  --goto-type-color-warning: #a5941e;
  --goto-yellow-100: #FFF7D9;
  --goto-yellow-200: #FFE88C;
  --goto-yellow-300: #FFCB00;
  --goto-yellow-400: #D9AD00;
  --goto-yellow-500: #B38F00;
  --goto-yellow-600: #997A00;
  --goto-yellow-700: #685714;
  --goto-neutral-550: #383D45;
  --goto-neutral-450: #5B646F;
  --goto-neutral-350: #828E9E;
  --goto-neutral-250: #B3BFCF;
  --goto-neutral-150: #DEE4Ec;
}
:root .theme-dark {
  --goto-blur-100: 4px;
  --goto-blur-200: 12px;
  --goto-blur-300: 24px;
  --goto-blur-400: 36px;
  --goto-blur-large: 50px;
  --goto-blur-medium: 30px;
  --goto-blur-small: 10px;
  --goto-blur-xlarge: 70px;
  --goto-elevation-100: 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.04);
  --goto-elevation-200: 0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.08), 0 1px 10px 0 rgba(0, 0, 0, 0.04);
  --goto-elevation-300: 0 5px 5px -3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.08), 0 3px 14px 2px rgba(0, 0, 0, 0.04);
  --goto-elevation-400: 0 8px 10px -5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.08), 0 6px 30px 5px rgba(0, 0, 0, 0.04);
  --goto-elevation-large: 0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2);
  --goto-elevation-medium: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
  --goto-elevation-none: none;
  --goto-elevation-small: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
  --goto-elevation-xlarge: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
  --goto-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --goto-font-family-mono: Menlo, Consolas, Monaco, 'Liberation Mono', 'Lucida Console', monospace;
  --goto-menu-width: 240px;
  --goto-topbar-background: var(--goto-ui-base-01);
  --goto-topbar-border: var(--goto-border);
  --goto-navigation-rail-background: var(--goto-ui-base-01);
  --goto-navigation-rail-border-right: var(--goto-border);
  --goto-navigation-rail-item-hover: var(--goto-hover-tertiary);
  --goto-navigation-rail-item-active: var(--goto-pressed-tertiary);
  --goto-navigation-rail-item-selected: transparent;
  --goto-navigation-rail-item-disabled: transparent;
  --goto-navigation-rail-icon: var(--goto-text-02);
  --goto-navigation-rail-icon-selected: var(--goto-icon-01);
  --goto-navigation-rail-icon-disabled: var(--goto-text-03);
  --goto-navigation-rail-text: var(--goto-text-02);
  --goto-navigation-rail-text-selected: var(--goto-text-02);
  --goto-navigation-rail-text-disabled: var(--goto-text-03);
  --goto-navigation-rail-focus: var(--goto-focus);
  --goto-navigation-rail-highlight: var(--goto-highlight);
  --goto-avatar-24: 700 0.625rem/0.875rem var(--goto-font-family);
  --goto-avatar-30: 700 0.75rem/1.065rem var(--goto-font-family);
  --goto-avatar-36: 700 0.875rem/0.9975rem var(--goto-font-family);
  --goto-avatar-48: 700 1.25rem/1.5rem var(--goto-font-family);
  --goto-avatar-64: 700 1.667rem/1.93372rem var(--goto-font-family);
  --goto-avatar-80: 700 2.25rem/2.6775rem var(--goto-font-family);
  --goto-avatar-180: 700 5.063rem/6.02497rem var(--goto-font-family);
  --goto-code-text-small: 400 0.75rem/0.9975rem var(--goto-font-family-mono);
  --goto-code-text-medium: 400 0.875rem/1.225rem var(--goto-font-family-mono);
  --goto-body-small: 400 0.875rem/1.5rem var(--goto-font-family);
  --goto-body-medium: 400 1rem/1.5rem var(--goto-font-family);
  --goto-body-large: 400 1.125rem/1.5rem var(--goto-font-family);
  --goto-body-small-semibold: 600 0.875rem/1.225rem var(--goto-font-family);
  --goto-body-medium-semibold: 600 1rem/1.4rem var(--goto-font-family);
  --goto-button-text-small: 600 0.75rem/1.05rem var(--goto-font-family);
  --goto-button-text-medium: 600 0.875rem/1.225rem var(--goto-font-family);
  --goto-button-text-large: 600 1rem/1.575rem var(--goto-font-family);
  --goto-button-text-xlarge: 600 1.125rem/1.575rem var(--goto-font-family);
  --goto-caption-default-01: 400 0.75rem/1.05rem var(--goto-font-family);
  --goto-caption-default-02: 600 0.75rem/1.05rem var(--goto-font-family);
  --goto-caption-small-01: 400 0.625rem/0.875rem var(--goto-font-family);
  --goto-caption-small-02: 600 0.625rem/0.875rem var(--goto-font-family);
  --goto-heading-small: 600 1.25rem/1.5rem var(--goto-font-family);
  --goto-heading-medium: 600 1.75rem/2rem var(--goto-font-family);
  --goto-heading-large: 700 2.25rem/2.5rem var(--goto-font-family);
  --goto-heading-xlarge: 700 3rem/3.25rem var(--goto-font-family);
  --goto-avatar-large: 700 1.25rem/1.5rem var(--goto-font-family);
  --goto-avatar-medium: 700 0.875rem/1.25rem var(--goto-font-family);
  --goto-avatar-small: 700 0.75rem/1rem var(--goto-font-family);
  --goto-avatar-xlarge: 700 1.625rem/2rem var(--goto-font-family);
  --goto-avatar-xsmall: 700 0.625rem/1rem var(--goto-font-family);
  --goto-avatar-xxlarge: 700 2.25rem/3rem var(--goto-font-family);
  --goto-avatar-xxxlarge: 700 5rem/6.25rem var(--goto-font-family);
  --goto-body-large-strong: 600 1.125rem/1.5rem var(--goto-font-family);
  --goto-body-medium-strong: 600 1rem/1.5rem var(--goto-font-family);
  --goto-body-small-strong: 600 0.875rem/1.5rem var(--goto-font-family);
  --goto-button-large: 600 1rem/1.5rem var(--goto-font-family);
  --goto-button-medium: 600 0.875rem/1.5rem var(--goto-font-family);
  --goto-button-small: 600 0.75rem/1.25rem var(--goto-font-family);
  --goto-button-xlarge: 600 1.125rem/1.5rem var(--goto-font-family);
  --goto-caption-medium: 400 0.75rem/1.25rem var(--goto-font-family);
  --goto-caption-medium-strong: 600 0.75rem/1.25rem var(--goto-font-family);
  --goto-caption-small: 400 0.625rem/1rem var(--goto-font-family);
  --goto-caption-small-strong: 600 0.625rem/1rem var(--goto-font-family);
  --goto-code-medium: 400 0.875rem/1.5rem var(--goto-font-family-mono);
  --goto-code-small: 400 0.75rem/1.25rem var(--goto-font-family-mono);
  --goto-layout-00: 0;
  --goto-layout-01: 16px;
  --goto-layout-02: 24px;
  --goto-layout-03: 32px;
  --goto-layout-04: 48px;
  --goto-layout-05: 64px;
  --goto-layout-06: 96px;
  --goto-layout-07: 160px;
  --goto-meeting: #F68D2E;
  --goto-room: #F68D2E;
  --goto-connect: #C4D600;
  --goto-webinar: #00C0F3;
  --goto-assist: #24658a;
  --goto-resolve: #7D33FF;
  --goto-training: #992977;
  --goto-open-voice: #a28bc4;
  --goto-jive: #cfe012;
  --goto-spacing-00: 0rem;
  --goto-spacing-01: 4px;
  --goto-spacing-02: 8px;
  --goto-spacing-03: 12px;
  --goto-spacing-04: 16px;
  --goto-spacing-05: 20px;
  --goto-spacing-06: 24px;
  --goto-spacing-07: 32px;
  --goto-spacing-08: 40px;
  --goto-spacing-09: 48px;
  --goto-spacing-10: 3.5rem;
  --goto-spacing-11: 4rem;
  --goto-transition-dialog-in: visibility 0s linear 0s, opacity 250ms 0s, transform 250ms;
  --goto-transition-dialog-out: visibility 0s linear 250ms, opacity 250ms 0s, transform 250ms;
  --goto-radius-circle: 1000px;
  --goto-radius-large: 12px;
  --goto-radius-medium: 8px;
  --goto-radius-none: 0px;
  --goto-radius-small: 4px;
  --goto-radius-xlarge: 16px;
  --goto-checkbox-checked-hover: var(--goto-hover-primary);
  --goto-checkbox-checked-pressed: var(--goto-pressed-primary);
  --goto-badge-background-disabled: var(--goto-disabled-02);
  --goto-badge-icon-disabled: var(--goto-disabled-04);
  --goto-alert-background: var(--goto-information-02);
  --goto-alert-border: var(--goto-interactive-01);
  --goto-chip-background: var(--goto-disabled-02);
  --goto-chip-background-selected: var(--goto-interactive-01);
  --goto-chip-background-selected-hover: var(--goto-hover-primary);
  --goto-chip-background-selected-active: var(--goto-pressed-primary);
  --goto-search-field-background: var(--goto-disabled-02);
  --goto-search-field-background-active: transparent;
  --goto-search-field-border-hover: var(--goto-disabled-02);
  --goto-search-field-icon-disabled: var(--goto-text-03);
  --goto-search-field-text-disabled: var(--goto-text-01);
  --goto-search-field-background-disabled: var(--goto-disabled-02);
  --goto-search-field-opacity-disabled: var(--disabled-opacity);
  --goto-search-field-clear-icon-background: var(--goto-text-02);
  --goto-select-inline-border: transparent;
  --goto-select-inline-font: var(--goto-caption-default-02);
  --goto-select-inline-border-hover: var(--goto-field-01);
  --goto-select-inline-background-hover: var(--goto-hover-secondary);
  --goto-select-inline-border-active: var(--goto-pressed-secondary);
  --goto-select-inline-background-active: var(--goto-pressed-secondary);
  --goto-round-button-icon-color: var(--goto-icon-01);
  --goto-round-button-border-success: var(--goto-success-01);
  --goto-round-button-border-danger: var(--goto-danger-01);
  --goto-tabs-indicator-background: var(--goto-interactive-01);
  --goto-skeleton-gradient: linear-gradient(90deg, transparent, var(--goto-disabled-01), transparent);
  --goto-input-success-border: var(--goto-success-01);
  --goto-input-danger-border: var(--goto-danger-01);
  --goto-nav-drawer-item-background-selected: var(--goto-interactive-01);
  --goto-nav-drawer-item-icon-color: var(--goto-text-02);
  --goto-nav-drawer-item-icon-color-selected: var(--goto-text-04);
  --goto-avatar-background-secondary-disabled: var(--goto-inverse-ui-05);
  --goto-avatar-color-secondary-disabled: var(--goto-disabled-04);
  --goto-avatar-border-secondary-disabled: 1px solid var(--goto-disabled-04);
  --goto-popover-border-color: var(--goto-ui-02);
  --goto-popover-elevation: var(--goto-elevation-300);
  --goto-empty-state-icon-color: var(--goto-disabled-04);
  --goto-radio-button-border-disabled: var(--goto-border);
  --goto-menu-background: inherit;
  --goto-menu-background-hover: var(--goto-interactive-01);
  --goto-menu-color-disabled: var(--goto-text-03);
  --goto-menu-color-hover: var(--goto-text-04);
  --goto-menu-icon-color: var(--goto-text-02);
  --goto-menu-elevation: none;
  --goto-menu-presence-available-color: var(--goto-text-04);
  --goto-menu-presence-busy-color: var(--goto-text-04);
  --goto-menu-presence-away-color: var(--goto-text-04);
  --goto-menu-presence-dnd-color: var(--goto-text-04);
  --goto-menu-presence-offline-color: var(--goto-text-04);
  --goto-button-neutral-inverse-border: var(--goto-inverse-border);
  --goto-button-neutral-inverse-background-hover: var(--goto-inverse-hover-01);
  --goto-button-neutral-inverse-background-active: var(--goto-inverse-pressed-01);
  --goto-snackbar-content-color: var(--goto-text-07);
  --goto-snackbar-background: var(--goto-neutral);
  --goto-progress-background-inverse: var(--goto-inverse-ui-05);
  --goto-switch-background-disabled: var(--goto-disabled-02);
  --goto-switch-checked-background-disabled: var(--goto-disabled-02);
  --goto-switch-knob-disabled: var(--goto-disabled-04);
  --goto-tile-background: var(--goto-interactive-01);
  --goto-tile-border: var(--goto-interactive-01);
  --goto-tile-border-secondary: var(--goto-interactive-01);
  --goto-tile-background-selected: var(--goto-interactive-01);
  --goto-tile-background-hover: var(--goto-interactive-01);
  --goto-tile-background-active: var(--goto-interactive-01);
  --goto-tile-background-secondary: var(--goto-interactive-02);
  --goto-tile-background-secondary-hover: var(--goto-hover-secondary);
  --goto-tile-background-secondary-active: var(--goto-pressed-secondary);
  --goto-tile-background-disabled: var(--goto-ui-01);
  --goto-tile-border-disabled: var(--goto-border);
  --goto-option-background-selected: var(--goto-interactive-01);
  --goto-option-color-selected: var(--goto-text-04);
  --goto-option-icon-color-selected: var(--goto-text-04);
  --goto-option-background-hover: var(--goto-interactive-01);
  --goto-option-color-disabled: var(--goto-disabled-04);
  --goto-option-icon-color-disabled: var(--goto-disabled-04);
  --goto-tooltip-font: var(--goto-caption-default-01);
  --goto-avatar-neutral: #6B7582;
  --goto-avatar-secondary: rgba(107, 117, 130, 0.1);
  --goto-avatar-secondary-icon-color: var(--goto-text-02);
  --goto-avatar-group-max-hint: #9AA8BB;
  --goto-avatar-primary-01: #BED9FE;
  --goto-avatar-primary-02: #3FC0C1;
  --goto-avatar-primary-03: #1F9CB6;
  --goto-avatar-primary-04: #7FFED1;
  --goto-avatar-primary-05: #70CE5F;
  --goto-avatar-primary-06: #00A96E;
  --goto-avatar-primary-07: #00A96E;
  --goto-avatar-primary-08: #CBB85D;
  --goto-avatar-primary-09: #D8AC00;
  --goto-avatar-primary-10: #FEBD7F;
  --goto-avatar-primary-11: #EF8953;
  --goto-avatar-primary-12: #DA781C;
  --goto-avatar-primary-13: #F9B3C1;
  --goto-avatar-primary-14: #F086BA;
  --goto-avatar-primary-15: #FC4C6F;
  --goto-avatar-primary-16: #D4BEFE;
  --goto-avatar-primary-17: #BF9EFF;
  --goto-avatar-primary-18: #9A66FE;
  --goto-border: rgba(255, 255, 255, 0.24);
  --goto-avatar-disabled-color: rgba(76, 83, 93, 0.8);
  --goto-danger-01: #FD4C6F;
  --goto-danger-02: rgba(161, 46, 72, 0.08);
  --goto-danger-03: rgba(253, 76, 111, 0.16);
  --goto-disabled-01: rgba(255, 255, 255, 0.08);
  --goto-disabled-02: rgba(217, 233, 255, 0.16);
  --goto-disabled-03: rgba(37, 40, 45, 0.36);
  --goto-disabled-04: rgba(255, 255, 255, 0.35);
  --goto-disabled-05: #FFFFFF;
  --goto-experience-badge-assist: #94CACE;
  --goto-experience-badge-customer: #FD94A9;
  --goto-experience-badge-meeting: #F68D2E;
  --goto-experience-badge-message: #80B5FF;
  --goto-experience-badge-voice: #00CC85;
  --goto-experience-badge-training: #CC94BB;
  --goto-experience-badge-webinar: #80DFF9;
  --goto-experience-badge-gotoresolve: #7D33FF;
  --goto-field-01: rgba(255, 255, 255, 0.24);
  --goto-field-02: rgba(255, 255, 255, 0.48);
  --goto-field-03: rgba(76, 83, 93, 0.16);
  --goto-field-04: rgba(255, 255, 255, 0.08);
  --goto-focus-error: #FD94A9;
  --goto-focus-success: #00CC85;
  --goto-highlight-error: 0 0 0 5px rgba(253, 76, 111, 0.24);
  --goto-highlight-success: 0 0 0 5px rgba(0, 170, 110, 0.24);
  --goto-highlight-error-small: 0 0 0 2px rgba(253, 76, 111, 0.24);
  --goto-highlight-success-small: 0 0 0 2px rgba(0, 170, 110, 0.24);
  --goto-hover-01: rgba(128, 181, 255, 0.12);
  --goto-hover-02: rgba(217, 233, 255, 0.24);
  --goto-hover-danger: #FD94A9;
  --goto-hover-primary: #80B5FF;
  --goto-hover-secondary: rgba(128, 181, 255, 0.12);
  --goto-hover-success: #00CC85;
  --goto-hover-tertiary: rgba(128, 181, 255, 0.12);
  --goto-icon-01: #80B5FF;
  --goto-icon-02: #FFFFFF;
  --goto-icon-03: #4C535D;
  --goto-icon-04: #FFFFFF;
  --goto-icon-05: rgba(0, 0, 0, 0.87);
  --goto-information-01: #006AFF;
  --goto-information-02: rgba(0, 79, 189, 0.08);
  --goto-information-03: rgba(64, 144, 255, 0.16);
  --goto-interactive-01: #4090FF;
  --goto-interactive-02: transparent;
  --goto-interactive-03: #006AFF;
  --goto-inverse-01: #FFFFFF;
  --goto-inverse-02: #25282D;
  --goto-inverse-border: rgba(76, 83, 93, 0.24);
  --goto-inverse-disabled: rgba(37, 40, 45, 0.36);
  --goto-inverse-hover-01: rgba(217, 233, 255, 0.44);
  --goto-inverse-focus: #004FBD;
  --goto-inverse-interactive-01: #006AFF;
  --goto-inverse-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
  --goto-inverse-pressed-01: rgba(217, 233, 255, 0.8);
  --goto-inverse-ui-05: rgba(154, 168, 187, 0.16);
  --goto-orange-01: #F68D2E;
  --goto-orange-03: rgba(246, 141, 46, 0.16);
  --goto-overlay-01: rgba(255, 255, 255, 0.7);
  --goto-presence-available: #00CC85;
  --goto-presence-away: #FFE88C;
  --goto-presence-busy: #FD4C6F;
  --goto-presence-dnd: #BFDAFF;
  --goto-presence-offline: rgba(255, 255, 255, 0.7);
  --goto-pressed-01: rgba(128, 181, 255, 0.24);
  --goto-pressed-02: rgba(217, 233, 255, 0.32);
  --goto-pressed-danger: #FABCC8;
  --goto-pressed-primary: #BFDAFF;
  --goto-pressed-secondary: rgba(128, 181, 255, 0.24);
  --goto-pressed-success: #80FFD2;
  --goto-pressed-tertiary: rgba(128, 181, 255, 0.24);
  --goto-purple-01: #9B66FF;
  --goto-purple-03: rgba(172, 128, 255, 0.16);
  --goto-success-01: #00AA6E;
  --goto-success-02: rgba(22, 101, 73, 0.08);
  --goto-success-03: rgba(0, 170, 110, 0.16);
  --goto-text-01: #FFFFFF;
  --goto-text-02: rgba(255, 255, 255, 0.67);
  --goto-text-03: rgba(255, 255, 255, 0.36);
  --goto-text-04: #25282D;
  --goto-text-05: rgba(255, 255, 255, 0.67);
  --goto-text-06: rgba(0, 0, 0, 0.87);
  --goto-text-07: rgba(37, 40, 45, 0.67);
  --goto-text-error-01: #E02D52;
  --goto-text-error-02: #FD94A9;
  --goto-text-info: #80B5FF;
  --goto-text-neutral: #25282D;
  --goto-text-success-01: #008858;
  --goto-text-success-02: #00CC85;
  --goto-text-warning-01: #D9AD00;
  --goto-text-warning-02: #FFCB00;
  --goto-warning-01: #D9AD00;
  --goto-warning-02: rgba(179, 143, 0, 0.08);
  --goto-warning-03: rgba(255, 203, 0, 0.16);
  --goto-ui-01: #383D45;
  --goto-ui-02: rgba(255, 255, 255, 0.24);
  --goto-ui-03: rgba(255, 255, 255, 0.24);
  --goto-ui-04: rgba(255, 255, 255, 0.08);
  --goto-ui-05: rgba(255, 255, 255, 0.24);
  --goto-ui-06: rgba(56, 61, 69, 0.04);
  --goto-ui-background: #25282D;
  --goto-ui-base-01: #383D45;
  --goto-ui-base-02: rgba(255, 255, 255, 0.24);
  --goto-focus: #80B5FF;
  --goto-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
  --goto-highlight-base: rgba(64, 144, 255, 0.24);
  --goto-highlight-small: 0 0 0 2px rgba(64, 144, 255, 0.24);
  --goto-link: #80B5FF;
  --goto-neutral: #F0F2F5;
  --goto-neutral-03: rgba(206, 216, 227, 0.16);
  --goto-contextual-menu-background-color: rgba(56, 61, 69, 0.8);
  --goto-toolbar-background-color: #383D45;
  --goto-toolbar-hover-background-color: #4C535D;
  --goto-toolbar-pressed-background-color: #80B5FF;
  --goto-toolbar-disabled-background-color: rgba(217, 233, 255, 0.08);
  --goto-toolbar-disabled-icon-color: rgba(255, 255, 255, 0.35);
  --goto-avatar-color-00: #bed9fe;
  --goto-avatar-color-01: #3fc0c1;
  --goto-avatar-color-02: #1f9cb6;
  --goto-avatar-color-10: #7ffed1;
  --goto-avatar-color-11: #70ce5f;
  --goto-avatar-color-12: #00a96e;
  --goto-avatar-color-20: #fee78b;
  --goto-avatar-color-21: #cbb85d;
  --goto-avatar-color-22: #d8ac00;
  --goto-avatar-color-30: #febd7f;
  --goto-avatar-color-31: #ef8953;
  --goto-avatar-color-32: #da781c;
  --goto-avatar-color-40: #f9b3c1;
  --goto-avatar-color-41: #f086ba;
  --goto-avatar-color-42: #fc4c6f;
  --goto-avatar-color-50: #d4befe;
  --goto-avatar-color-51: #bf9eff;
  --goto-avatar-color-52: #9a66fe;
  --goto-avatar-color-primary: rgba(217, 227, 233, 0.5);
  --goto-avatar-color-secondary: rgba(217, 227, 233, 0.1);
  --goto-background-color-default: black;
  --goto-background-color-secondary: #2a3238;
  --goto-badge-color-assist: #29969d;
  --goto-badge-color-audio: #f2dd06;
  --goto-badge-color-custom: white;
  --goto-badge-color-customer: #fd4c6f;
  --goto-badge-color-disabled: rgba(255, 255, 255, 0.3);
  --goto-badge-color-files: rgba(152, 182, 201, 0.7);
  --goto-badge-color-gotoresolve: #7d33ff;
  --goto-badge-color-meeting: #f68d2e;
  --goto-badge-color-message: #4090ff;
  --goto-badge-color-training: #992977;
  --goto-badge-color-voice: #00aa6e;
  --goto-badge-color-webinar: #00c0f3;
  --goto-blue-100: #D9E9FF;
  --goto-blue-200: #BFDAFF;
  --goto-blue-300: #80B5FF;
  --goto-blue-400: #4090FF;
  --goto-blue-500: #006AFF;
  --goto-blue-600: #004FBD;
  --goto-blue-700: #0f3599;
  --goto-border-color-brand: #53ce73;
  --goto-border-color-danger: #d33a61;
  --goto-border-color-default: rgba(152, 182, 201, 0.5);
  --goto-border-color-inverted: rgba(88, 121, 143, 0.5);
  --goto-border-color-persistent: rgba(88, 121, 143, 0.5);
  --goto-border-color-secondary: #2a3238;
  --goto-border-color-success: #53ce73;
  --goto-border-color-warning: #f2dd06;
  --goto-brand-100: #d1f6cf;
  --goto-brand-200: #a1e8a5;
  --goto-brand-300: #53ce73;
  --goto-brand-400: #2ba95c;
  --goto-brand-500: #1b8756;
  --goto-brand-600: #146459;
  --goto-brand-700: #004f49;
  --goto-focus-border-color-danger: black;
  --goto-focus-border-color-default: black;
  --goto-focus-border-color-persistent: black;
  --goto-focus-border-color-success: black;
  --goto-focus-color-highlight-danger: #f4c3bf;
  --goto-focus-color-highlight-default: white;
  --goto-focus-color-highlight-persistent: white;
  --goto-focus-color-highlight-success: #a1e8a5;
  --goto-gradient-color-skeleton: linear-gradient(90deg, rgba(152, 182, 201, 0) 0%, rgba(152, 182, 201, 0.1) 50%, rgba(152, 182, 201, 0) 100%);
  --goto-green-100: #D9FFF2;
  --goto-green-200: #80FFD2;
  --goto-green-300: #00CC85;
  --goto-green-400: #00AA6E;
  --goto-green-500: #008858;
  --goto-green-600: #166549;
  --goto-green-700: #004f49;
  --goto-icon-color-brand-default: #53ce73;
  --goto-icon-color-brand-persistent: #53ce73;
  --goto-icon-color-danger: #d33a61;
  --goto-icon-color-default: white;
  --goto-icon-color-disabled: rgba(255, 255, 255, 0.3);
  --goto-icon-color-inverted: black;
  --goto-icon-color-persistent: white;
  --goto-icon-color-persistent-disabled: rgba(255, 255, 255, 0.3);
  --goto-icon-color-secondary: rgba(217, 227, 233, 0.7);
  --goto-icon-color-success: #53ce73;
  --goto-icon-color-warning: #f2dd06;
  --goto-interactive-color-brand-default: #53ce73;
  --goto-interactive-color-brand-hover: #a1e8a5;
  --goto-interactive-color-brand-pressed: #d1f6cf;
  --goto-interactive-color-danger-default: #d33a61;
  --goto-interactive-color-danger-hover: #d96f7e;
  --goto-interactive-color-danger-pressed: #e6a2a2;
  --goto-interactive-color-disabled: rgba(255, 255, 255, 0.1);
  --goto-interactive-color-neutral-default: #2a3238;
  --goto-interactive-color-neutral-hover: #3d4852;
  --goto-interactive-color-neutral-pressed: #465b6b;
  --goto-interactive-color-persistent-default: black;
  --goto-interactive-color-persistent-hover: #2a3238;
  --goto-interactive-color-persistent-pressed: #3d4852;
  --goto-interactive-color-primary-default: white;
  --goto-interactive-color-primary-hover: #f2f6f7;
  --goto-interactive-color-primary-pressed: #d9e3e9;
  --goto-interactive-color-secondary-default: #98b6c9;
  --goto-interactive-color-secondary-hover: rgba(152, 182, 201, 0.1);
  --goto-interactive-color-secondary-pressed: rgba(152, 182, 201, 0.3);
  --goto-interactive-color-success-default: #53ce73;
  --goto-interactive-color-success-hover: #a1e8a5;
  --goto-interactive-color-success-pressed: #d1f6cf;
  --goto-neutral-000: #FFFFFF;
  --goto-neutral-050: #F7F8Fa;
  --goto-neutral-100: #F0F2F5;
  --goto-neutral-200: #E0E4EA;
  --goto-neutral-300: #9AA8BB;
  --goto-neutral-400: #6B7582;
  --goto-neutral-500: #4C535D;
  --goto-neutral-600: #25282D;
  --goto-neutral-700: #000000;
  --goto-neutral-800: #2a3238;
  --goto-neutral-900: black;
  --goto-orange-100: #FEEDDE;
  --goto-orange-200: #FFC48C;
  --goto-orange-300: #F68D2E;
  --goto-orange-400: #DB781C;
  --goto-orange-500: #B35F11;
  --goto-orange-600: #8C4400;
  --goto-orange-700: #703c0a;
  --goto-purple-100: #E6D9FF;
  --goto-purple-200: #D5BFFF;
  --goto-purple-300: #AC80FF;
  --goto-purple-400: #9B66FF;
  --goto-purple-500: #7B44E4;
  --goto-purple-600: #6739BF;
  --goto-purple-700: #321c9c;
  --goto-red-100: #FEE2E8;
  --goto-red-200: #FABCC8;
  --goto-red-300: #FD94A9;
  --goto-red-400: #FD4C6F;
  --goto-red-500: #E02D52;
  --goto-red-600: #A12E45;
  --goto-red-700: #801248;
  --goto-scrim-color: rgba(42, 50, 56, 0.7);
  --goto-surface-color-brand-default: #53ce73;
  --goto-surface-color-brand-secondary: rgba(83, 206, 115, 0.1);
  --goto-surface-color-danger-default: #d33a61;
  --goto-surface-color-danger-secondary: rgba(211, 58, 97, 0.1);
  --goto-surface-color-default: black;
  --goto-surface-color-default-semitransparent: rgba(0, 0, 0, 0.7);
  --goto-surface-color-inverted: white;
  --goto-surface-color-persistent: black;
  --goto-surface-color-secondary: #2a3238;
  --goto-surface-color-success-default: #53ce73;
  --goto-surface-color-success-secondary: rgba(83, 206, 115, 0.1);
  --goto-surface-color-tertiary: rgba(152, 182, 201, 0.5);
  --goto-surface-color-utility-orange: rgba(246, 141, 46, 0.1);
  --goto-surface-color-utility-purple: rgba(194, 164, 255, 0.1);
  --goto-surface-color-warning-default: #f2dd06;
  --goto-surface-color-warning-secondary: rgba(242, 221, 6, 0.1);
  --goto-type-color-brand-default: #53ce73;
  --goto-type-color-brand-persistent: #53ce73;
  --goto-type-color-danger: #e6a2a2;
  --goto-type-color-default: white;
  --goto-type-color-disabled: rgba(255, 255, 255, 0.3);
  --goto-type-color-inverted: black;
  --goto-type-color-persistent: white;
  --goto-type-color-persistent-disabled: rgba(255, 255, 255, 0.3);
  --goto-type-color-secondary: rgba(217, 227, 233, 0.7);
  --goto-type-color-secondary-inverted: rgba(70, 91, 107, 0.7);
  --goto-type-color-success: #53ce73;
  --goto-type-color-warning: #f2dd06;
  --goto-yellow-100: #FFF7D9;
  --goto-yellow-200: #FFE88C;
  --goto-yellow-300: #FFCB00;
  --goto-yellow-400: #D9AD00;
  --goto-yellow-500: #B38F00;
  --goto-yellow-600: #997A00;
  --goto-yellow-700: #685714;
  --goto-neutral-550: #383D45;
  --goto-neutral-450: #5B646F;
  --goto-neutral-350: #828E9E;
  --goto-neutral-250: #B3BFCF;
  --goto-neutral-150: #DEE4Ec;
}

:root [rebranding2021] {
  --goto-avatar-24: var(--goto-avatar-xsmall);
  --goto-avatar-30: var(--goto-avatar-small);
  --goto-avatar-36: var(--goto-avatar-medium);
  --goto-avatar-48: var(--goto-avatar-large);
  --goto-avatar-64: var(--goto-avatar-xlarge);
  --goto-avatar-80: var(--goto-avatar-xxlarge);
  --goto-avatar-180: var(--goto-avatar-xxxlarge);
  --goto-avatar-primary-01: var(--goto-avatar-color-00);
  --goto-avatar-primary-02: var(--goto-avatar-color-01);
  --goto-avatar-primary-03: var(--goto-avatar-color-02);
  --goto-avatar-primary-04: var(--goto-avatar-color-10);
  --goto-avatar-primary-05: var(--goto-avatar-color-11);
  --goto-avatar-primary-06: var(--goto-avatar-color-12);
  --goto-avatar-primary-07: var(--goto-avatar-color-20);
  --goto-avatar-primary-08: var(--goto-avatar-color-21);
  --goto-avatar-primary-09: var(--goto-avatar-color-22);
  --goto-avatar-primary-10: var(--goto-avatar-color-30);
  --goto-avatar-primary-11: var(--goto-avatar-color-31);
  --goto-avatar-primary-12: var(--goto-avatar-color-32);
  --goto-avatar-primary-13: var(--goto-avatar-color-40);
  --goto-avatar-primary-14: var(--goto-avatar-color-41);
  --goto-avatar-primary-15: var(--goto-avatar-color-42);
  --goto-avatar-primary-16: var(--goto-avatar-color-50);
  --goto-avatar-primary-17: var(--goto-avatar-color-51);
  --goto-avatar-primary-18: var(--goto-avatar-color-52);
  --goto-avatar-secondary: var(--goto-avatar-color-secondary);
  --goto-blur-100: var(--goto-blur-small);
  --goto-blur-200: var(--goto-blur-medium);
  --goto-blur-300: var(--goto-blur-large);
  --goto-blur-400: var(--goto-blur-xlarge);
  --goto-border: var(--goto-border-color-default);
  --goto-button-text-large: var(--goto-button-large);
  --goto-button-text-medium: var(--goto-button-medium);
  --goto-button-text-small: var(--goto-button-small);
  --goto-button-text-xlarge: var(--goto-button-xlarge);
  --goto-caption-default-01: var(--goto-caption-medium);
  --goto-caption-default-02: var(--goto-caption-medium-strong);
  --goto-caption-small-01: var(--goto-caption-small);
  --goto-caption-small-02: var(--goto-caption-small-strong);
  --goto-code-text-medium: var(--goto-code-medium);
  --goto-code-text-small: var(--goto-code-small);
  --goto-contextual-menu-background-color: var(--goto-surface-color-default);
  --goto-danger-01: var(--goto-surface-color-danger-default);
  --goto-danger-02: var(--goto-surface-color-danger-secondary);
  --goto-danger-03: var(--goto-surface-color-danger-secondary);
  --goto-disabled-01: var(--goto-surface-color-disabled);
  --goto-disabled-02: var(--goto-interactive-color-disabled);
  --goto-disabled-03: var(--goto-type-color-disabled);
  --goto-disabled-04: var(--goto-interactive-color-disabled);
  --goto-elevation-100: var(--goto-elevation-small);
  --goto-elevation-200: var(--goto-elevation-medium);
  --goto-elevation-300: var(--goto-elevation-large);
  --goto-elevation-400: var(--goto-elevation-xlarge);
  --goto-experience-badge-assist: var(--goto-badge-color-assist);
  --goto-experience-badge-customer: var(--goto-badge-color-customer);
  --goto-experience-badge-gotoresolve: var(--goto-badge-color-gotoresolve);
  --goto-experience-badge-meeting: var(--goto-badge-color-meeting);
  --goto-experience-badge-message: var(--goto-badge-color-message);
  --goto-experience-badge-training: var(--goto-badge-color-training);
  --goto-experience-badge-voice: var(--goto-badge-color-voice);
  --goto-experience-badge-webinar: var(--goto-badge-color-webinar);
  --goto-field-01: var(--goto-interactive-color-neutral-default);
  --goto-field-02: var(--goto-interactive-color-neutral-hover);
  --goto-field-03: var(--goto-interactive-color-disabled);
  --goto-field-04: var(--goto-surface-color-default);
  --goto-focus-error: var(--goto-focus-border-color-danger);
  --goto-focus-success: var(--goto-focus-border-color-success);
  --goto-focus: var(--goto-focus-border-color-default);
  --goto-highlight-error: 0 0 0 2px var(--goto-focus-color-highlight-danger);
  --goto-highlight-success: 0 0 0 2px var(--goto-focus-color-highlight-success);
  --goto-highlight: 0 0 0 2px var(--goto-focus-color-highlight-default);
  --goto-highlight-small: 0 0 0 2px var(--goto-focus-color-highlight-default);
  --goto-hover-01: var(--goto-interactive-color-secondary-hover);
  --goto-hover-02: var(--goto-interactive-color-secondary-hover);
  --goto-hover-danger: var(--goto-interactive-color-danger-hover);
  --goto-hover-primary: var(--goto-interactive-color-primary-hover);
  --goto-hover-secondary: var(--goto-interactive-color-secondary-hover);
  --goto-hover-success: var(--goto-interactive-color-success-hover);
  --goto-hover-tertiary: var(--goto-interactive-color-secondary-hover);
  --goto-icon-01: var(--goto-icon-color-brand-default);
  --goto-icon-02: var(--goto-icon-color-inverted);
  --goto-icon-03: var(--goto-icon-color-default);
  --goto-icon-04: var(--goto-icon-color-default);
  --goto-icon-05: var(--goto-icon-color-inverted);
  --goto-information-01: var(--goto-surface-color-brand-default);
  --goto-information-02: var(--goto-surface-color-brand-secondary);
  --goto-information-03: var(--goto-surface-color-brand-secondary);
  --goto-interactive-01: var(--goto-interactive-color-primary-default);
  --goto-inverse-01: var(--goto-surface-color-inverted);
  --goto-inverse-02: var(--goto-surface-color-default);
  --goto-inverse-border: var(--goto-border-color-secondary);
  --goto-inverse-interactive-01: var(--goto-surface-color-brand-default);
  --goto-inverse-ui-05: var(--goto-surface-color-inverted);
  --goto-link: var(--goto-type-color-brand-default);
  --goto-neutral-03: var(--goto-surface-color-secondary);
  --goto-neutral: var(--goto-surface-color-inverted);
  --goto-orange-01: var(--goto-surface-color-utility-orange);
  --goto-orange-03: var(--goto-surface-color-utility-orange);
  --goto-overlay-01: var(--goto-scrim-color);
  --goto-presence-available: var(--goto-icon-color-success);
  --goto-presence-away: var(--goto-icon-color-warning);
  --goto-presence-busy: var(--goto-icon-color-danger);
  --goto-presence-dnd: var(--goto-icon-color-default);
  --goto-presence-offline: var(--goto-icon-color-default);
  --goto-pressed-01: var(--goto-interactive-color-secondary-pressed);
  --goto-pressed-02: var(--goto-interactive-color-neutral-pressed);
  --goto-pressed-danger: var(--goto-interactive-color-danger-pressed);
  --goto-pressed-primary: var(--goto-interactive-color-primary-pressed);
  --goto-pressed-secondary: var(--goto-interactive-color-secondary-pressed);
  --goto-pressed-success: var(--goto-interactive-color-success-pressed);
  --goto-pressed-tertiary: var(--goto-interactive-color-secondary-pressed);
  --goto-purple-01: var(--goto-icon-color-utility-purple);
  --goto-purple-03: var(--goto-surface-color-utility-purple);
  --goto-success-01: var(--goto-surface-color-success-default);
  --goto-success-02: var(--goto-surface-color-success-secondary);
  --goto-success-03: var(--goto-surface-color-success-secondary);
  --goto-text-01: var(--goto-type-color-default);
  --goto-text-02: var(--goto-type-color-secondary);
  --goto-text-03: var(--goto-type-color-disabled);
  --goto-text-04: var(--goto-type-color-inverted);
  --goto-text-05: var(--goto-type-color-secondary);
  --goto-text-06: var(--goto-type-color-inverted);
  --goto-text-07: var(--goto-type-color-inverted);
  --goto-text-error-01: var(--goto-type-color-danger);
  --goto-text-error-02: var(--goto-type-color-danger);
  --goto-text-info: var(--goto-type-color-interactive);
  --goto-text-neutral: var(--goto-type-color-default);
  --goto-text-success-01: var(--goto-type-color-success);
  --goto-text-success-02: var(--goto-type-color-success);
  --goto-text-warning-01: var(--goto-type-color-warning);
  --goto-text-warning-02: var(--goto-type-color-warning);
  --goto-ui-01: var(--goto-surface-color-default);
  --goto-ui-02: var(--goto-border-color-default);
  --goto-ui-03: var(--goto-border-color-default);
  --goto-ui-04: var(--goto-surface-color-secondary);
  --goto-ui-05: var(--goto-surface-color-secondary);
  --goto-ui-06: var(--goto-surface-color-default);
  --goto-ui-background: var(--goto-background-color-default);
  --goto-ui-base-01: var(--goto-background-color-secondary);
  --goto-ui-base-02: var(--goto-background-color-secondary);
  --goto-warning-01: var(--goto-surface-color-warning-default);
  --goto-warning-02: var(--goto-surface-color-warning-secondary);
  --goto-toolbar-background-color: var(--goto-interactive-color-neutral-default);
  --goto-toolbar-hover-background-color: var(--goto-interactive-color-neutral-hover);
  --goto-toolbar-pressed-background-color: var(--goto-interactive-color-primary-default);
  --goto-toolbar-disabled-background-color: var(--goto-interactive-color-disabled);
  --goto-toolbar-disabled-icon-color: var(--goto-icon-color-disabled);
  --goto-topbar-background: var(--goto-surface-color-default);
  --goto-topbar-border: var(--goto-border-color-default);
  --goto-navigation-rail-background: var(--goto-surface-color-persistent);
  --goto-navigation-rail-border-right: var(--goto-border-color-persistent);
  --goto-navigation-rail-item-hover: var(--goto-interactive-color-persistent-hover);
  --goto-navigation-rail-item-active: var(--goto-interactive-color-persistent-pressed);
  --goto-navigation-rail-item-selected: transparent;
  --goto-navigation-rail-item-disabled: transparent;
  --goto-navigation-rail-icon: var(--goto-icon-color-persistent);
  --goto-navigation-rail-icon-selected: var(--goto-icon-color-brand-persistent);
  --goto-navigation-rail-icon-disabled: var(--goto-icon-color-persistent-disabled);
  --goto-navigation-rail-text: var(--goto-type-color-persistent);
  --goto-navigation-rail-text-selected: var(--goto-type-color-brand-persistent);
  --goto-navigation-rail-text-disabled: var(--goto-type-color-persistent-disabled);
  --goto-navigation-rail-focus: var(--goto-focus-border-color-persistent);
  --goto-navigation-rail-highlight: 0 0 0 2px var(--goto-focus-color-highlight-persistent);
  --goto-checkbox-checked-hover: var(--goto-interactive-color-brand-hover);
  --goto-checkbox-checked-pressed: var(--goto-interactive-color-brand-pressed);
  --goto-badge-background-disabled: var(--goto-surface-color-secondary);
  --goto-badge-icon-disabled: var(--goto-icon-color-disabled);
  --goto-alert-background: var(--goto-surface-color-secondary);
  --goto-alert-border: var(--goto-border-color-default);
  --goto-chip-background: var(--goto-interactive-color-neutral-default);
  --goto-chip-background-selected: var(--goto-interactive-color-brand-default);
  --goto-chip-background-selected-hover: var(--goto-interactive-color-brand-hover);
  --goto-chip-background-selected-active: var(--goto-interactive-color-brand-pressed);
  --goto-search-field-background: var(--goto-surface-color-secondary);
  --goto-search-field-background-active: var(--goto-surface-color-default);
  --goto-search-field-border-hover: var(--goto-border-color-default);
  --goto-search-field-icon-disabled: var(--goto-icon-color-disabled);
  --goto-search-field-text-disabled: var(--goto-type-color-disabled);
  --goto-search-field-background-disabled: var(--goto-surface-color-secondary);
  --goto-search-field-opacity-disabled: 1;
  --goto-search-field-clear-icon-background: var(--goto-icon-color-secondary);
  --goto-select-inline-border: var(--goto-interactive-color-neutral-default);
  --goto-select-inline-font: var(--goto-caption-medium);
  --goto-select-inline-border-hover: var(--goto-interactive-color-neutral-hover);
  --goto-select-inline-background-hover: var(--goto-interactive-color-secondary-hover);
  --goto-select-inline-border-active: var(--goto-interactive-color-neutral-pressed);
  --goto-select-inline-background-active: var(--goto-interactive-color-secondary-pressed);
  --goto-round-button-icon-color: var(--goto-icon-color-default);
  --goto-round-button-border-success: var(--goto-border-color-success);
  --goto-round-button-border-danger: var(--goto-border-color-danger);
  --goto-tabs-indicator-background: var(--goto-surface-color-brand-default);
  --goto-skeleton-gradient: var(--goto-gradient-color-skeleton);
  --goto-input-success-border: var(--goto-border-color-success);
  --goto-input-danger-border: var(--goto-border-color-danger);
  --goto-nav-drawer-item-background-selected: var(--goto-surface-color-brand-default);
  --goto-nav-drawer-item-icon-color: var(--goto-icon-color-secondary);
  --goto-nav-drawer-item-icon-color-selected: var(--goto-icon-color-inverted);
  --goto-avatar-background-secondary-disabled: var(--goto-interactive-color-disabled);
  --goto-avatar-color-secondary-disabled: var(--goto-interactive-color-disabled);
  --goto-avatar-border-secondary-disabled: inherit;
  --goto-popover-border-color: var(--goto-border-color-secondary);
  --goto-popover-elevation: var(--goto-elevation-medium);
  --goto-empty-state-icon-color: var(--goto-icon-color-disabled);
  --goto-radio-button-border-disabled: transparent;
  --goto-menu-background: var(--goto-surface-color-default);
  --goto-menu-background-hover: var(--goto-interactive-color-secondary-hover);
  --goto-menu-color-hover: var(--goto-type-color-default);
  --goto-menu-icon-color: var(--goto-icon-color-default);
  --goto-menu-elevation: var(--goto-elevation-medium);
  --goto-button-neutral-inverse-border: var(--goto-border-color-inverted);
  --goto-button-neutral-inverse-background-hover: var(--goto-interactive-color-primary-hover);
  --goto-button-neutral-inverse-background-active: var(--goto-interactive-color-primary-pressed);
  --goto-snackbar-content-color: var(--goto-type-color-secondary-inverted);
  --goto-snackbar-background: var(--goto-surface-color-inverted);
  --goto-progress-background-inverse: var(--goto-surface-color-tertiary);
  --goto-switch-background-disabled: var(--goto-interactive-color-secondary-pressed);
  --goto-switch-checked-background-disabled: var(--goto-interactive-color-disabled);
  --goto-switch-knob-disabled: var(--goto-icon-color-inverted);
  --goto-tile-background: var(--goto-interactive-color-brand-default);
  --goto-tile-border: var(--goto-interactive-color-secondary-default);
  --goto-tile-border-secondary: var(--goto-border-color-default);
  --goto-tile-background-selected: var(--goto-interactive-color-brand-default);
  --goto-tile-background-hover: var(--goto-interactive-color-brand-hover);
  --goto-tile-background-active: var(--goto-interactive-color-brand-pressed);
  --goto-tile-background-secondary: var(--goto-surface-color-default);
  --goto-tile-background-secondary-hover: var(--goto-interactive-color-secondary-hover);
  --goto-tile-background-secondary-active: var(--goto-interactive-color-secondary-pressed);
  --goto-tile-background-disabled: var(--goto-interactive-color-disabled);
  --goto-tile-border-disabled: var(--goto-interactive-color-disabled);
  --goto-option-background-selected: var(--goto-surface-color-secondary);
  --goto-option-color-selected: var(--goto-type-color-default);
  --goto-option-icon-color-selected: var(--goto-icon-color-default);
  --goto-option-background-hover: var(--goto-interactive-color-secondary-hover);
  --goto-option-color-disabled: var(--goto-type-color-disabled);
  --goto-option-icon-color-disabled: var(--goto-icon-color-disabled);
  --goto-tooltip-font: var(--goto-caption-medium);
  --goto-menu-presence-available-color: var(--goto-icon-color-success);
  --goto-menu-presence-busy-color: var(--goto-icon-color-danger);
  --goto-menu-presence-away-color: var(--goto-icon-color-warning);
  --goto-menu-presence-dnd-color: var(--goto-icon-color-default);
  --goto-menu-presence-offline-color: var(--goto-icon-color-default);
}

@media (prefers-color-scheme: dark) {
  .enable-darkmode {
    --goto-blur-100: 4px;
    --goto-blur-200: 12px;
    --goto-blur-300: 24px;
    --goto-blur-400: 36px;
    --goto-blur-large: 50px;
    --goto-blur-medium: 30px;
    --goto-blur-small: 10px;
    --goto-blur-xlarge: 70px;
    --goto-elevation-100: 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.04);
    --goto-elevation-200: 0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.08), 0 1px 10px 0 rgba(0, 0, 0, 0.04);
    --goto-elevation-300: 0 5px 5px -3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.08), 0 3px 14px 2px rgba(0, 0, 0, 0.04);
    --goto-elevation-400: 0 8px 10px -5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.08), 0 6px 30px 5px rgba(0, 0, 0, 0.04);
    --goto-elevation-large: 0px 9px 12px rgba(0, 0, 0, 0.14), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 5px 6px rgba(0, 0, 0, 0.2);
    --goto-elevation-medium: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
    --goto-elevation-none: none;
    --goto-elevation-small: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    --goto-elevation-xlarge: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
    --goto-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    --goto-font-family-mono: Menlo, Consolas, Monaco, 'Liberation Mono', 'Lucida Console', monospace;
    --goto-menu-width: 240px;
    --goto-topbar-background: var(--goto-ui-base-01);
    --goto-topbar-border: var(--goto-border);
    --goto-navigation-rail-background: var(--goto-ui-base-01);
    --goto-navigation-rail-border-right: var(--goto-border);
    --goto-navigation-rail-item-hover: var(--goto-hover-tertiary);
    --goto-navigation-rail-item-active: var(--goto-pressed-tertiary);
    --goto-navigation-rail-item-selected: transparent;
    --goto-navigation-rail-item-disabled: transparent;
    --goto-navigation-rail-icon: var(--goto-text-02);
    --goto-navigation-rail-icon-selected: var(--goto-icon-01);
    --goto-navigation-rail-icon-disabled: var(--goto-text-03);
    --goto-navigation-rail-text: var(--goto-text-02);
    --goto-navigation-rail-text-selected: var(--goto-text-02);
    --goto-navigation-rail-text-disabled: var(--goto-text-03);
    --goto-navigation-rail-focus: var(--goto-focus);
    --goto-navigation-rail-highlight: var(--goto-highlight);
    --goto-avatar-24: 700 0.625rem/0.875rem var(--goto-font-family);
    --goto-avatar-30: 700 0.75rem/1.065rem var(--goto-font-family);
    --goto-avatar-36: 700 0.875rem/0.9975rem var(--goto-font-family);
    --goto-avatar-48: 700 1.25rem/1.5rem var(--goto-font-family);
    --goto-avatar-64: 700 1.667rem/1.93372rem var(--goto-font-family);
    --goto-avatar-80: 700 2.25rem/2.6775rem var(--goto-font-family);
    --goto-avatar-180: 700 5.063rem/6.02497rem var(--goto-font-family);
    --goto-code-text-small: 400 0.75rem/0.9975rem var(--goto-font-family-mono);
    --goto-code-text-medium: 400 0.875rem/1.225rem var(--goto-font-family-mono);
    --goto-body-small: 400 0.875rem/1.5rem var(--goto-font-family);
    --goto-body-medium: 400 1rem/1.5rem var(--goto-font-family);
    --goto-body-large: 400 1.125rem/1.5rem var(--goto-font-family);
    --goto-body-small-semibold: 600 0.875rem/1.225rem var(--goto-font-family);
    --goto-body-medium-semibold: 600 1rem/1.4rem var(--goto-font-family);
    --goto-button-text-small: 600 0.75rem/1.05rem var(--goto-font-family);
    --goto-button-text-medium: 600 0.875rem/1.225rem var(--goto-font-family);
    --goto-button-text-large: 600 1rem/1.575rem var(--goto-font-family);
    --goto-button-text-xlarge: 600 1.125rem/1.575rem var(--goto-font-family);
    --goto-caption-default-01: 400 0.75rem/1.05rem var(--goto-font-family);
    --goto-caption-default-02: 600 0.75rem/1.05rem var(--goto-font-family);
    --goto-caption-small-01: 400 0.625rem/0.875rem var(--goto-font-family);
    --goto-caption-small-02: 600 0.625rem/0.875rem var(--goto-font-family);
    --goto-heading-small: 600 1.25rem/1.5rem var(--goto-font-family);
    --goto-heading-medium: 600 1.75rem/2rem var(--goto-font-family);
    --goto-heading-large: 700 2.25rem/2.5rem var(--goto-font-family);
    --goto-heading-xlarge: 700 3rem/3.25rem var(--goto-font-family);
    --goto-avatar-large: 700 1.25rem/1.5rem var(--goto-font-family);
    --goto-avatar-medium: 700 0.875rem/1.25rem var(--goto-font-family);
    --goto-avatar-small: 700 0.75rem/1rem var(--goto-font-family);
    --goto-avatar-xlarge: 700 1.625rem/2rem var(--goto-font-family);
    --goto-avatar-xsmall: 700 0.625rem/1rem var(--goto-font-family);
    --goto-avatar-xxlarge: 700 2.25rem/3rem var(--goto-font-family);
    --goto-avatar-xxxlarge: 700 5rem/6.25rem var(--goto-font-family);
    --goto-body-large-strong: 600 1.125rem/1.5rem var(--goto-font-family);
    --goto-body-medium-strong: 600 1rem/1.5rem var(--goto-font-family);
    --goto-body-small-strong: 600 0.875rem/1.5rem var(--goto-font-family);
    --goto-button-large: 600 1rem/1.5rem var(--goto-font-family);
    --goto-button-medium: 600 0.875rem/1.5rem var(--goto-font-family);
    --goto-button-small: 600 0.75rem/1.25rem var(--goto-font-family);
    --goto-button-xlarge: 600 1.125rem/1.5rem var(--goto-font-family);
    --goto-caption-medium: 400 0.75rem/1.25rem var(--goto-font-family);
    --goto-caption-medium-strong: 600 0.75rem/1.25rem var(--goto-font-family);
    --goto-caption-small: 400 0.625rem/1rem var(--goto-font-family);
    --goto-caption-small-strong: 600 0.625rem/1rem var(--goto-font-family);
    --goto-code-medium: 400 0.875rem/1.5rem var(--goto-font-family-mono);
    --goto-code-small: 400 0.75rem/1.25rem var(--goto-font-family-mono);
    --goto-layout-00: 0;
    --goto-layout-01: 16px;
    --goto-layout-02: 24px;
    --goto-layout-03: 32px;
    --goto-layout-04: 48px;
    --goto-layout-05: 64px;
    --goto-layout-06: 96px;
    --goto-layout-07: 160px;
    --goto-meeting: #F68D2E;
    --goto-room: #F68D2E;
    --goto-connect: #C4D600;
    --goto-webinar: #00C0F3;
    --goto-assist: #24658a;
    --goto-resolve: #7D33FF;
    --goto-training: #992977;
    --goto-open-voice: #a28bc4;
    --goto-jive: #cfe012;
    --goto-spacing-00: 0rem;
    --goto-spacing-01: 4px;
    --goto-spacing-02: 8px;
    --goto-spacing-03: 12px;
    --goto-spacing-04: 16px;
    --goto-spacing-05: 20px;
    --goto-spacing-06: 24px;
    --goto-spacing-07: 32px;
    --goto-spacing-08: 40px;
    --goto-spacing-09: 48px;
    --goto-spacing-10: 3.5rem;
    --goto-spacing-11: 4rem;
    --goto-transition-dialog-in: visibility 0s linear 0s, opacity 250ms 0s, transform 250ms;
    --goto-transition-dialog-out: visibility 0s linear 250ms, opacity 250ms 0s, transform 250ms;
    --goto-radius-circle: 1000px;
    --goto-radius-large: 12px;
    --goto-radius-medium: 8px;
    --goto-radius-none: 0px;
    --goto-radius-small: 4px;
    --goto-radius-xlarge: 16px;
    --goto-checkbox-checked-hover: var(--goto-hover-primary);
    --goto-checkbox-checked-pressed: var(--goto-pressed-primary);
    --goto-badge-background-disabled: var(--goto-disabled-02);
    --goto-badge-icon-disabled: var(--goto-disabled-04);
    --goto-alert-background: var(--goto-information-02);
    --goto-alert-border: var(--goto-interactive-01);
    --goto-chip-background: var(--goto-disabled-02);
    --goto-chip-background-selected: var(--goto-interactive-01);
    --goto-chip-background-selected-hover: var(--goto-hover-primary);
    --goto-chip-background-selected-active: var(--goto-pressed-primary);
    --goto-search-field-background: var(--goto-disabled-02);
    --goto-search-field-background-active: transparent;
    --goto-search-field-border-hover: var(--goto-disabled-02);
    --goto-search-field-icon-disabled: var(--goto-text-03);
    --goto-search-field-text-disabled: var(--goto-text-01);
    --goto-search-field-background-disabled: var(--goto-disabled-02);
    --goto-search-field-opacity-disabled: var(--disabled-opacity);
    --goto-search-field-clear-icon-background: var(--goto-text-02);
    --goto-select-inline-border: transparent;
    --goto-select-inline-font: var(--goto-caption-default-02);
    --goto-select-inline-border-hover: var(--goto-field-01);
    --goto-select-inline-background-hover: var(--goto-hover-secondary);
    --goto-select-inline-border-active: var(--goto-pressed-secondary);
    --goto-select-inline-background-active: var(--goto-pressed-secondary);
    --goto-round-button-icon-color: var(--goto-icon-01);
    --goto-round-button-border-success: var(--goto-success-01);
    --goto-round-button-border-danger: var(--goto-danger-01);
    --goto-tabs-indicator-background: var(--goto-interactive-01);
    --goto-skeleton-gradient: linear-gradient(90deg, transparent, var(--goto-disabled-01), transparent);
    --goto-input-success-border: var(--goto-success-01);
    --goto-input-danger-border: var(--goto-danger-01);
    --goto-nav-drawer-item-background-selected: var(--goto-interactive-01);
    --goto-nav-drawer-item-icon-color: var(--goto-text-02);
    --goto-nav-drawer-item-icon-color-selected: var(--goto-text-04);
    --goto-avatar-background-secondary-disabled: var(--goto-inverse-ui-05);
    --goto-avatar-color-secondary-disabled: var(--goto-disabled-04);
    --goto-avatar-border-secondary-disabled: 1px solid var(--goto-disabled-04);
    --goto-popover-border-color: var(--goto-ui-02);
    --goto-popover-elevation: var(--goto-elevation-300);
    --goto-empty-state-icon-color: var(--goto-disabled-04);
    --goto-radio-button-border-disabled: var(--goto-border);
    --goto-menu-background: inherit;
    --goto-menu-background-hover: var(--goto-interactive-01);
    --goto-menu-color-disabled: var(--goto-text-03);
    --goto-menu-color-hover: var(--goto-text-04);
    --goto-menu-icon-color: var(--goto-text-02);
    --goto-menu-elevation: none;
    --goto-menu-presence-available-color: var(--goto-text-04);
    --goto-menu-presence-busy-color: var(--goto-text-04);
    --goto-menu-presence-away-color: var(--goto-text-04);
    --goto-menu-presence-dnd-color: var(--goto-text-04);
    --goto-menu-presence-offline-color: var(--goto-text-04);
    --goto-button-neutral-inverse-border: var(--goto-inverse-border);
    --goto-button-neutral-inverse-background-hover: var(--goto-inverse-hover-01);
    --goto-button-neutral-inverse-background-active: var(--goto-inverse-pressed-01);
    --goto-snackbar-content-color: var(--goto-text-07);
    --goto-snackbar-background: var(--goto-neutral);
    --goto-progress-background-inverse: var(--goto-inverse-ui-05);
    --goto-switch-background-disabled: var(--goto-disabled-02);
    --goto-switch-checked-background-disabled: var(--goto-disabled-02);
    --goto-switch-knob-disabled: var(--goto-disabled-04);
    --goto-tile-background: var(--goto-interactive-01);
    --goto-tile-border: var(--goto-interactive-01);
    --goto-tile-border-secondary: var(--goto-interactive-01);
    --goto-tile-background-selected: var(--goto-interactive-01);
    --goto-tile-background-hover: var(--goto-interactive-01);
    --goto-tile-background-active: var(--goto-interactive-01);
    --goto-tile-background-secondary: var(--goto-interactive-02);
    --goto-tile-background-secondary-hover: var(--goto-hover-secondary);
    --goto-tile-background-secondary-active: var(--goto-pressed-secondary);
    --goto-tile-background-disabled: var(--goto-ui-01);
    --goto-tile-border-disabled: var(--goto-border);
    --goto-option-background-selected: var(--goto-interactive-01);
    --goto-option-color-selected: var(--goto-text-04);
    --goto-option-icon-color-selected: var(--goto-text-04);
    --goto-option-background-hover: var(--goto-interactive-01);
    --goto-option-color-disabled: var(--goto-disabled-04);
    --goto-option-icon-color-disabled: var(--goto-disabled-04);
    --goto-tooltip-font: var(--goto-caption-default-01);
    --goto-avatar-neutral: #6B7582;
    --goto-avatar-secondary: rgba(107, 117, 130, 0.1);
    --goto-avatar-secondary-icon-color: var(--goto-text-02);
    --goto-avatar-group-max-hint: #9AA8BB;
    --goto-avatar-primary-01: #BED9FE;
    --goto-avatar-primary-02: #3FC0C1;
    --goto-avatar-primary-03: #1F9CB6;
    --goto-avatar-primary-04: #7FFED1;
    --goto-avatar-primary-05: #70CE5F;
    --goto-avatar-primary-06: #00A96E;
    --goto-avatar-primary-07: #00A96E;
    --goto-avatar-primary-08: #CBB85D;
    --goto-avatar-primary-09: #D8AC00;
    --goto-avatar-primary-10: #FEBD7F;
    --goto-avatar-primary-11: #EF8953;
    --goto-avatar-primary-12: #DA781C;
    --goto-avatar-primary-13: #F9B3C1;
    --goto-avatar-primary-14: #F086BA;
    --goto-avatar-primary-15: #FC4C6F;
    --goto-avatar-primary-16: #D4BEFE;
    --goto-avatar-primary-17: #BF9EFF;
    --goto-avatar-primary-18: #9A66FE;
    --goto-border: rgba(255, 255, 255, 0.24);
    --goto-avatar-disabled-color: rgba(76, 83, 93, 0.8);
    --goto-danger-01: #FD4C6F;
    --goto-danger-02: rgba(161, 46, 72, 0.08);
    --goto-danger-03: rgba(253, 76, 111, 0.16);
    --goto-disabled-01: rgba(255, 255, 255, 0.08);
    --goto-disabled-02: rgba(217, 233, 255, 0.16);
    --goto-disabled-03: rgba(37, 40, 45, 0.36);
    --goto-disabled-04: rgba(255, 255, 255, 0.35);
    --goto-disabled-05: #FFFFFF;
    --goto-experience-badge-assist: #94CACE;
    --goto-experience-badge-customer: #FD94A9;
    --goto-experience-badge-meeting: #F68D2E;
    --goto-experience-badge-message: #80B5FF;
    --goto-experience-badge-voice: #00CC85;
    --goto-experience-badge-training: #CC94BB;
    --goto-experience-badge-webinar: #80DFF9;
    --goto-experience-badge-gotoresolve: #7D33FF;
    --goto-field-01: rgba(255, 255, 255, 0.24);
    --goto-field-02: rgba(255, 255, 255, 0.48);
    --goto-field-03: rgba(76, 83, 93, 0.16);
    --goto-field-04: rgba(255, 255, 255, 0.08);
    --goto-focus-error: #FD94A9;
    --goto-focus-success: #00CC85;
    --goto-highlight-error: 0 0 0 5px rgba(253, 76, 111, 0.24);
    --goto-highlight-success: 0 0 0 5px rgba(0, 170, 110, 0.24);
    --goto-highlight-error-small: 0 0 0 2px rgba(253, 76, 111, 0.24);
    --goto-highlight-success-small: 0 0 0 2px rgba(0, 170, 110, 0.24);
    --goto-hover-01: rgba(128, 181, 255, 0.12);
    --goto-hover-02: rgba(217, 233, 255, 0.24);
    --goto-hover-danger: #FD94A9;
    --goto-hover-primary: #80B5FF;
    --goto-hover-secondary: rgba(128, 181, 255, 0.12);
    --goto-hover-success: #00CC85;
    --goto-hover-tertiary: rgba(128, 181, 255, 0.12);
    --goto-icon-01: #80B5FF;
    --goto-icon-02: #FFFFFF;
    --goto-icon-03: #4C535D;
    --goto-icon-04: #FFFFFF;
    --goto-icon-05: rgba(0, 0, 0, 0.87);
    --goto-information-01: #006AFF;
    --goto-information-02: rgba(0, 79, 189, 0.08);
    --goto-information-03: rgba(64, 144, 255, 0.16);
    --goto-interactive-01: #4090FF;
    --goto-interactive-02: transparent;
    --goto-interactive-03: #006AFF;
    --goto-inverse-01: #FFFFFF;
    --goto-inverse-02: #25282D;
    --goto-inverse-border: rgba(76, 83, 93, 0.24);
    --goto-inverse-disabled: rgba(37, 40, 45, 0.36);
    --goto-inverse-hover-01: rgba(217, 233, 255, 0.44);
    --goto-inverse-focus: #004FBD;
    --goto-inverse-interactive-01: #006AFF;
    --goto-inverse-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
    --goto-inverse-pressed-01: rgba(217, 233, 255, 0.8);
    --goto-inverse-ui-05: rgba(154, 168, 187, 0.16);
    --goto-orange-01: #F68D2E;
    --goto-orange-03: rgba(246, 141, 46, 0.16);
    --goto-overlay-01: rgba(255, 255, 255, 0.7);
    --goto-presence-available: #00CC85;
    --goto-presence-away: #FFE88C;
    --goto-presence-busy: #FD4C6F;
    --goto-presence-dnd: #BFDAFF;
    --goto-presence-offline: rgba(255, 255, 255, 0.7);
    --goto-pressed-01: rgba(128, 181, 255, 0.24);
    --goto-pressed-02: rgba(217, 233, 255, 0.32);
    --goto-pressed-danger: #FABCC8;
    --goto-pressed-primary: #BFDAFF;
    --goto-pressed-secondary: rgba(128, 181, 255, 0.24);
    --goto-pressed-success: #80FFD2;
    --goto-pressed-tertiary: rgba(128, 181, 255, 0.24);
    --goto-purple-01: #9B66FF;
    --goto-purple-03: rgba(172, 128, 255, 0.16);
    --goto-success-01: #00AA6E;
    --goto-success-02: rgba(22, 101, 73, 0.08);
    --goto-success-03: rgba(0, 170, 110, 0.16);
    --goto-text-01: #FFFFFF;
    --goto-text-02: rgba(255, 255, 255, 0.67);
    --goto-text-03: rgba(255, 255, 255, 0.36);
    --goto-text-04: #25282D;
    --goto-text-05: rgba(255, 255, 255, 0.67);
    --goto-text-06: rgba(0, 0, 0, 0.87);
    --goto-text-07: rgba(37, 40, 45, 0.67);
    --goto-text-error-01: #E02D52;
    --goto-text-error-02: #FD94A9;
    --goto-text-info: #80B5FF;
    --goto-text-neutral: #25282D;
    --goto-text-success-01: #008858;
    --goto-text-success-02: #00CC85;
    --goto-text-warning-01: #D9AD00;
    --goto-text-warning-02: #FFCB00;
    --goto-warning-01: #D9AD00;
    --goto-warning-02: rgba(179, 143, 0, 0.08);
    --goto-warning-03: rgba(255, 203, 0, 0.16);
    --goto-ui-01: #383D45;
    --goto-ui-02: rgba(255, 255, 255, 0.24);
    --goto-ui-03: rgba(255, 255, 255, 0.24);
    --goto-ui-04: rgba(255, 255, 255, 0.08);
    --goto-ui-05: rgba(255, 255, 255, 0.24);
    --goto-ui-06: rgba(56, 61, 69, 0.04);
    --goto-ui-background: #25282D;
    --goto-ui-base-01: #383D45;
    --goto-ui-base-02: rgba(255, 255, 255, 0.24);
    --goto-focus: #80B5FF;
    --goto-highlight: 0 0 0 5px rgba(64, 144, 255, 0.24);
    --goto-highlight-base: rgba(64, 144, 255, 0.24);
    --goto-highlight-small: 0 0 0 2px rgba(64, 144, 255, 0.24);
    --goto-link: #80B5FF;
    --goto-neutral: #F0F2F5;
    --goto-neutral-03: rgba(206, 216, 227, 0.16);
    --goto-contextual-menu-background-color: rgba(56, 61, 69, 0.8);
    --goto-toolbar-background-color: #383D45;
    --goto-toolbar-hover-background-color: #4C535D;
    --goto-toolbar-pressed-background-color: #80B5FF;
    --goto-toolbar-disabled-background-color: rgba(217, 233, 255, 0.08);
    --goto-toolbar-disabled-icon-color: rgba(255, 255, 255, 0.35);
    --goto-avatar-color-00: #bed9fe;
    --goto-avatar-color-01: #3fc0c1;
    --goto-avatar-color-02: #1f9cb6;
    --goto-avatar-color-10: #7ffed1;
    --goto-avatar-color-11: #70ce5f;
    --goto-avatar-color-12: #00a96e;
    --goto-avatar-color-20: #fee78b;
    --goto-avatar-color-21: #cbb85d;
    --goto-avatar-color-22: #d8ac00;
    --goto-avatar-color-30: #febd7f;
    --goto-avatar-color-31: #ef8953;
    --goto-avatar-color-32: #da781c;
    --goto-avatar-color-40: #f9b3c1;
    --goto-avatar-color-41: #f086ba;
    --goto-avatar-color-42: #fc4c6f;
    --goto-avatar-color-50: #d4befe;
    --goto-avatar-color-51: #bf9eff;
    --goto-avatar-color-52: #9a66fe;
    --goto-avatar-color-primary: rgba(217, 227, 233, 0.5);
    --goto-avatar-color-secondary: rgba(217, 227, 233, 0.1);
    --goto-background-color-default: black;
    --goto-background-color-secondary: #2a3238;
    --goto-badge-color-assist: #29969d;
    --goto-badge-color-audio: #f2dd06;
    --goto-badge-color-custom: white;
    --goto-badge-color-customer: #fd4c6f;
    --goto-badge-color-disabled: rgba(255, 255, 255, 0.3);
    --goto-badge-color-files: rgba(152, 182, 201, 0.7);
    --goto-badge-color-gotoresolve: #7d33ff;
    --goto-badge-color-meeting: #f68d2e;
    --goto-badge-color-message: #4090ff;
    --goto-badge-color-training: #992977;
    --goto-badge-color-voice: #00aa6e;
    --goto-badge-color-webinar: #00c0f3;
    --goto-blue-100: #D9E9FF;
    --goto-blue-200: #BFDAFF;
    --goto-blue-300: #80B5FF;
    --goto-blue-400: #4090FF;
    --goto-blue-500: #006AFF;
    --goto-blue-600: #004FBD;
    --goto-blue-700: #0f3599;
    --goto-border-color-brand: #53ce73;
    --goto-border-color-danger: #d33a61;
    --goto-border-color-default: rgba(152, 182, 201, 0.5);
    --goto-border-color-inverted: rgba(88, 121, 143, 0.5);
    --goto-border-color-persistent: rgba(88, 121, 143, 0.5);
    --goto-border-color-secondary: #2a3238;
    --goto-border-color-success: #53ce73;
    --goto-border-color-warning: #f2dd06;
    --goto-brand-100: #d1f6cf;
    --goto-brand-200: #a1e8a5;
    --goto-brand-300: #53ce73;
    --goto-brand-400: #2ba95c;
    --goto-brand-500: #1b8756;
    --goto-brand-600: #146459;
    --goto-brand-700: #004f49;
    --goto-focus-border-color-danger: black;
    --goto-focus-border-color-default: black;
    --goto-focus-border-color-persistent: black;
    --goto-focus-border-color-success: black;
    --goto-focus-color-highlight-danger: #f4c3bf;
    --goto-focus-color-highlight-default: white;
    --goto-focus-color-highlight-persistent: white;
    --goto-focus-color-highlight-success: #a1e8a5;
    --goto-gradient-color-skeleton: linear-gradient(90deg, rgba(152, 182, 201, 0) 0%, rgba(152, 182, 201, 0.1) 50%, rgba(152, 182, 201, 0) 100%);
    --goto-green-100: #D9FFF2;
    --goto-green-200: #80FFD2;
    --goto-green-300: #00CC85;
    --goto-green-400: #00AA6E;
    --goto-green-500: #008858;
    --goto-green-600: #166549;
    --goto-green-700: #004f49;
    --goto-icon-color-brand-default: #53ce73;
    --goto-icon-color-brand-persistent: #53ce73;
    --goto-icon-color-danger: #d33a61;
    --goto-icon-color-default: white;
    --goto-icon-color-disabled: rgba(255, 255, 255, 0.3);
    --goto-icon-color-inverted: black;
    --goto-icon-color-persistent: white;
    --goto-icon-color-persistent-disabled: rgba(255, 255, 255, 0.3);
    --goto-icon-color-secondary: rgba(217, 227, 233, 0.7);
    --goto-icon-color-success: #53ce73;
    --goto-icon-color-warning: #f2dd06;
    --goto-interactive-color-brand-default: #53ce73;
    --goto-interactive-color-brand-hover: #a1e8a5;
    --goto-interactive-color-brand-pressed: #d1f6cf;
    --goto-interactive-color-danger-default: #d33a61;
    --goto-interactive-color-danger-hover: #d96f7e;
    --goto-interactive-color-danger-pressed: #e6a2a2;
    --goto-interactive-color-disabled: rgba(255, 255, 255, 0.1);
    --goto-interactive-color-neutral-default: #2a3238;
    --goto-interactive-color-neutral-hover: #3d4852;
    --goto-interactive-color-neutral-pressed: #465b6b;
    --goto-interactive-color-persistent-default: black;
    --goto-interactive-color-persistent-hover: #2a3238;
    --goto-interactive-color-persistent-pressed: #3d4852;
    --goto-interactive-color-primary-default: white;
    --goto-interactive-color-primary-hover: #f2f6f7;
    --goto-interactive-color-primary-pressed: #d9e3e9;
    --goto-interactive-color-secondary-default: #98b6c9;
    --goto-interactive-color-secondary-hover: rgba(152, 182, 201, 0.1);
    --goto-interactive-color-secondary-pressed: rgba(152, 182, 201, 0.3);
    --goto-interactive-color-success-default: #53ce73;
    --goto-interactive-color-success-hover: #a1e8a5;
    --goto-interactive-color-success-pressed: #d1f6cf;
    --goto-neutral-000: #FFFFFF;
    --goto-neutral-050: #F7F8Fa;
    --goto-neutral-100: #F0F2F5;
    --goto-neutral-200: #E0E4EA;
    --goto-neutral-300: #9AA8BB;
    --goto-neutral-400: #6B7582;
    --goto-neutral-500: #4C535D;
    --goto-neutral-600: #25282D;
    --goto-neutral-700: #000000;
    --goto-neutral-800: #2a3238;
    --goto-neutral-900: black;
    --goto-orange-100: #FEEDDE;
    --goto-orange-200: #FFC48C;
    --goto-orange-300: #F68D2E;
    --goto-orange-400: #DB781C;
    --goto-orange-500: #B35F11;
    --goto-orange-600: #8C4400;
    --goto-orange-700: #703c0a;
    --goto-purple-100: #E6D9FF;
    --goto-purple-200: #D5BFFF;
    --goto-purple-300: #AC80FF;
    --goto-purple-400: #9B66FF;
    --goto-purple-500: #7B44E4;
    --goto-purple-600: #6739BF;
    --goto-purple-700: #321c9c;
    --goto-red-100: #FEE2E8;
    --goto-red-200: #FABCC8;
    --goto-red-300: #FD94A9;
    --goto-red-400: #FD4C6F;
    --goto-red-500: #E02D52;
    --goto-red-600: #A12E45;
    --goto-red-700: #801248;
    --goto-scrim-color: rgba(42, 50, 56, 0.7);
    --goto-surface-color-brand-default: #53ce73;
    --goto-surface-color-brand-secondary: rgba(83, 206, 115, 0.1);
    --goto-surface-color-danger-default: #d33a61;
    --goto-surface-color-danger-secondary: rgba(211, 58, 97, 0.1);
    --goto-surface-color-default: black;
    --goto-surface-color-default-semitransparent: rgba(0, 0, 0, 0.7);
    --goto-surface-color-inverted: white;
    --goto-surface-color-persistent: black;
    --goto-surface-color-secondary: #2a3238;
    --goto-surface-color-success-default: #53ce73;
    --goto-surface-color-success-secondary: rgba(83, 206, 115, 0.1);
    --goto-surface-color-tertiary: rgba(152, 182, 201, 0.5);
    --goto-surface-color-utility-orange: rgba(246, 141, 46, 0.1);
    --goto-surface-color-utility-purple: rgba(194, 164, 255, 0.1);
    --goto-surface-color-warning-default: #f2dd06;
    --goto-surface-color-warning-secondary: rgba(242, 221, 6, 0.1);
    --goto-type-color-brand-default: #53ce73;
    --goto-type-color-brand-persistent: #53ce73;
    --goto-type-color-danger: #e6a2a2;
    --goto-type-color-default: white;
    --goto-type-color-disabled: rgba(255, 255, 255, 0.3);
    --goto-type-color-inverted: black;
    --goto-type-color-persistent: white;
    --goto-type-color-persistent-disabled: rgba(255, 255, 255, 0.3);
    --goto-type-color-secondary: rgba(217, 227, 233, 0.7);
    --goto-type-color-secondary-inverted: rgba(70, 91, 107, 0.7);
    --goto-type-color-success: #53ce73;
    --goto-type-color-warning: #f2dd06;
    --goto-yellow-100: #FFF7D9;
    --goto-yellow-200: #FFE88C;
    --goto-yellow-300: #FFCB00;
    --goto-yellow-400: #D9AD00;
    --goto-yellow-500: #B38F00;
    --goto-yellow-600: #997A00;
    --goto-yellow-700: #685714;
    --goto-neutral-550: #383D45;
    --goto-neutral-450: #5B646F;
    --goto-neutral-350: #828E9E;
    --goto-neutral-250: #B3BFCF;
    --goto-neutral-150: #DEE4Ec;
  }
}
body {
  font-size: 16px;
}`; export default styles;